import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, InjectionToken, Injectable, Inject, forwardRef, Component, ChangeDetectionStrategy, Input, Injector, ViewChild, EventEmitter, HostBinding, Output, TemplateRef, Optional, ContentChild, ContentChildren, NgModule } from '@angular/core';
import * as i3$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i3$3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i12 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i6 from '@firestitch/colorpicker';
import { randomColor, FsColorPickerModule } from '@firestitch/colorpicker';
import * as i10 from '@firestitch/form';
import { FsFormModule } from '@firestitch/form';
import * as i4$1 from '@firestitch/list';
import { FsListModule } from '@firestitch/list';
import * as i2$1 from '@firestitch/autocomplete';
import { FsAutocompleteStaticDirective, FsAutocompleteComponent, FsAutocompleteModule } from '@firestitch/autocomplete';
import * as i3$4 from '@firestitch/autocomplete-chips';
import { FsAutocompleteChipsStaticDirective, FsAutocompleteChipsModule } from '@firestitch/autocomplete-chips';
import * as i5$1 from '@firestitch/chip';
import { FsChipModule } from '@firestitch/chip';
import * as i3$6 from '@firestitch/dialog';
import { FsDialogModule } from '@firestitch/dialog';
import * as i3$2 from '@firestitch/file';
import { FsFileModule } from '@firestitch/file';
import * as i3$5 from '@firestitch/label';
import { FsLabelModule } from '@firestitch/label';
import * as i4$2 from '@firestitch/menu';
import { FsMenuModule } from '@firestitch/menu';
import { FsScrollModule } from '@firestitch/scroll';
import * as i5$2 from '@firestitch/tree';
import { TreeActionType, FsTreeComponent, FsTreeModule } from '@firestitch/tree';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { get, set, clone, sortBy, cloneDeep, merge } from 'lodash-es';
import { ItemType } from '@firestitch/filter';
import * as i4 from '@angular/material/core';

class FsAttributeAutocompleteChipsStaticDirective extends FsAutocompleteChipsStaticDirective {
}
FsAttributeAutocompleteChipsStaticDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteChipsStaticDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FsAttributeAutocompleteChipsStaticDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeAutocompleteChipsStaticDirective, selector: "[fsAttributeAutocompleteChipsStatic]", usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteChipsStaticDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAttributeAutocompleteChipsStatic]',
                }]
        }] });

class FsAttributeTemplateDirective {
    constructor() { }
}
FsAttributeTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAttributeTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeTemplateDirective, selector: "[fsAttributeTemplate]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAttributeTemplate]',
                }]
        }], ctorParameters: function () { return []; } });

class FsAttributeListColumnDirective {
}
FsAttributeListColumnDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeListColumnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAttributeListColumnDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeListColumnDirective, selector: "[fsAttributeListColumn]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeListColumnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsAttributeListColumn]',
                }]
        }] });

function getAttributeValue(attribute, mapping) {
    if (!mapping) {
        return null;
    }
    return get(attribute, mapping);
}
function setAttributeValue(attribute, mapping, value) {
    if (!mapping) {
        return null;
    }
    return set(attribute, mapping, value);
}

class AttributeItem {
    constructor(data = {}, attributesConfig, parent = null) {
        this.id = null;
        this.klass = null;
        this.name = null;
        this.configs = null;
        this._children = [];
        this._image = null;
        this._backgroundColor = null;
        this._color = null;
        this._attribute = {};
        this._attributesConfig = attributesConfig;
        this._parent = parent;
        this._config = this._attributesConfig.getConfig(data.class);
        this._initParent(data);
        this._initAttribute(data);
        this._initChildren(data);
    }
    get attributesConfig() {
        return this._attributesConfig;
    }
    get config() {
        return this._config;
    }
    get image() {
        return this._image;
    }
    set image(value) {
        this.setImage(value);
    }
    get backgroundColor() {
        return this._backgroundColor;
    }
    set backgroundColor(value) {
        this.setBackgroundColor(value);
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this.setColor(value);
    }
    get children() {
        return this._children.slice();
    }
    get parent() {
        return this._parent;
    }
    setImage(value) {
        if (this._config.image === 2 /* Parent */ && this.parent) {
            this._image = this.parent.image;
        }
        else {
            this._image = value;
        }
    }
    setBackgroundColor(value) {
        if (this._config.backgroundColor === 2 /* Parent */ && this.parent) {
            this._backgroundColor = this.parent.backgroundColor;
        }
        else {
            this._backgroundColor = value;
        }
    }
    setColor(value) {
        if (this._config.color === 2 /* Parent */ && this.parent) {
            this._color = this.parent.color;
        }
        else {
            this._color = value;
        }
    }
    /**
     * Prepare attirubte for save on the server
     */
    toJSON() {
        const mapping = this._config.mapping;
        const attribute = clone(this._attribute);
        setAttributeValue(attribute, mapping.id, this.id);
        setAttributeValue(attribute, mapping.name, this.name);
        setAttributeValue(attribute, mapping.image, this.image);
        setAttributeValue(attribute, mapping.backgroundColor, this.backgroundColor);
        setAttributeValue(attribute, mapping.color, this.color);
        setAttributeValue(attribute, mapping.configs, this.configs);
        if (mapping.childAttributes && this._children && Array.isArray(this._children)) {
            const children = this._children.reduce((acc, child) => {
                acc.push(child.toJSON());
                return acc;
            }, []);
            setAttributeValue(attribute, mapping.childAttributes, children);
        }
        return attribute;
    }
    /**
     * Data for using in attributes
     *
     * Unlike toJSON() this method will return an object based on mapping
     */
    getData() {
        const mapping = this._config.mapping;
        const attribute = {
            class: this.klass,
            id: this.id,
            name: this.name,
            image: this.image,
            backgroundColor: this.backgroundColor,
            color: this.color,
            configs: this.configs,
            original: this,
        };
        if (mapping.childAttributes && this._children && Array.isArray(this._children)) {
            const children = this._children.reduce((acc, child) => {
                acc.push(child.getData());
                return acc;
            }, []);
            setAttributeValue(attribute, mapping.childAttributes, children);
        }
        return attribute;
    }
    _initAttribute(data) {
        const mapping = this._config.mapping;
        this._attribute = clone(data);
        this.klass = data.class;
        this.id = getAttributeValue(data, mapping.id);
        this.name = getAttributeValue(data, mapping.name);
        this.configs = getAttributeValue(data, mapping.configs);
        if (Array.isArray(this.configs)) {
            this.configs = {};
        }
        if (this._config.image !== 0 /* Disabled */) {
            this.setImage(getAttributeValue(data, mapping.image));
        }
        this.setBackgroundColor(getAttributeValue(data, mapping.backgroundColor));
        this.setColor(getAttributeValue(data, mapping.color));
    }
    _initParent(data) {
        if (!this._parent) {
            if (this._config.mapping.parentAttribute) {
                const parent = getAttributeValue(data, this._config.mapping.parentAttribute);
                if (parent) {
                    this._parent = new AttributeItem(parent, this._attributesConfig);
                }
            }
        }
    }
    _initChildren(data) {
        const children = getAttributeValue(data, this._config.mapping.childAttributes);
        if (children && Array.isArray(children)) {
            this._children = children.map((child) => new AttributeItem(child, this._attributesConfig, this));
        }
    }
}

class AttributeConfigItem {
    constructor(data = {}, mapping = {}) {
        this._initConfig(data, mapping);
    }
    get klass() {
        return this._klass;
    }
    get childClass() {
        return this._childClass;
    }
    get image() {
        return this._image;
    }
    get backgroundColor() {
        return this._backgroundColor;
    }
    get color() {
        return this._color;
    }
    get name() {
        return this._name;
    }
    get pluralName() {
        return this._pluralName;
    }
    get order() {
        return this._order;
    }
    get selectedOrder() {
        return this._selectedOrder;
    }
    get fields() {
        return this._fields;
    }
    get mapping() {
        return this._mapping;
    }
    get hasImage() {
        return this._image === 1 /* Enabled */;
    }
    get hasNestedImage() {
        return this._image === 2 /* Parent */;
    }
    _initConfig(data, mapping) {
        this._klass = data.class;
        this._childClass = data.childClass;
        this._image = data.image;
        this._backgroundColor = data.backgroundColor;
        this._color = data.color;
        this._name = data.name;
        this._pluralName = data.pluralName;
        this._order = data.order;
        this._selectedOrder = data.selectedOrder;
        this._fields = Array.isArray(data.fields) ? data.fields.slice() : data.fields;
        this._mapping = mapping;
        this.hasEditableImage = this._image === 1 /* Enabled */;
    }
}

const FS_ATTRIBUTE_DEFAULT_CONFIG = new InjectionToken('fs-attribute.default-config');
const FS_ATTRIBUTE_CONFIG = new InjectionToken('fs-attribute.config');
const FS_ATTRIBUTE_FIELD_DATA = new InjectionToken('fs-attribute.field-data');

class AttributesConfig {
    constructor(_fsAttributeConfig) {
        this._fsAttributeConfig = _fsAttributeConfig;
        this._configs = new Map();
        this._initConfigs(_fsAttributeConfig.configs, _fsAttributeConfig.mapping);
    }
    getAttributes(e) {
        return this._fsAttributeConfig.getAttributes(e)
            .pipe(map((response) => {
            const data = response.data.map((attribute) => {
                return new AttributeItem(attribute, this);
            });
            return { data: data, paging: response.paging };
        }));
    }
    getAttributeConfig(klass) {
        const attributeConfig = this._fsAttributeConfig.configs.find(eachConfig => {
            return eachConfig.class === klass;
        });
        return attributeConfig;
    }
    sortAttributes(klass, attributes) {
        const attrConfig = this.getAttributeConfig(klass);
        if (attrConfig && attrConfig.order === 2 /* Alphabetical */) {
            return sortBy(attributes, (o) => { return o.name; });
        }
        else {
            return attributes;
        }
    }
    deleteAttribute(event) {
        return this._fsAttributeConfig.deleteAttribute(event.toJSON());
    }
    deleteConfirmation(event) {
        return this._fsAttributeConfig.deleteConfirmation(event.toJSON());
    }
    saveAttribute(event) {
        event.attribute = event && event.attribute
            ? event.attribute.toJSON()
            : null;
        return this._fsAttributeConfig.saveAttribute(event);
    }
    getAttributeTree(event) {
        return this._fsAttributeConfig.getAttributeTree(event)
            .pipe(map((response) => {
            const data = response.attributes.map((attribute) => {
                return new AttributeItem(attribute, this).getData();
            });
            return { data: data };
        }));
    }
    getSelectedAttributes(e) {
        return this._fsAttributeConfig.getSelectedAttributes(e)
            .pipe(map((response) => {
            const data = response.data.map((attribute) => {
                return new AttributeItem(attribute, this);
            });
            return { data: data, paging: response.paging };
        }));
    }
    compare(o1, o2) {
        return this._fsAttributeConfig.compareAttributes(o1, o2);
    }
    compareAttributes(o1, o2) {
        return this._fsAttributeConfig.compareAttributes(o1 && o1.toJSON(), o2 && o2.toJSON());
    }
    attributeSelectionChanged(event) {
        if (event && event.attribute) {
            event.attribute = event.attribute.toJSON();
        }
        if (event && event.value) {
            event.value = event.value.toJSON();
        }
        if (event.attributes && Array.isArray(event.attributes)) {
            event.attributes = event.attributes.map((attr) => attr.toJSON());
        }
        if (event.reorder) {
            event.reorder.item = event.reorder.item.toJSON();
            if (event.reorder.items && Array.isArray(event.reorder.items)) {
                event.reorder.items = event.reorder.items.map((item) => item.data.toJSON());
            }
        }
        return this._fsAttributeConfig.attributeSelectionChanged(event);
    }
    reorderAttributes(event) {
        if (event && Array.isArray(event.attributes)) {
            event.attributes = event.attributes.map((attr) => attr.data.toJSON());
        }
        return this._fsAttributeConfig.reorderAttributes(event);
    }
    saveAttributeImage(event) {
        event.attribute = event && event.attribute
            ? event.attribute.toJSON()
            : null;
        return this._fsAttributeConfig.saveAttributeImage(event);
    }
    canDropAttribute(node, fromParent, toParent, dropPosition, prevElement, nextElement) {
        return this._fsAttributeConfig.canDropTreeAttribute(node, fromParent, toParent, dropPosition, prevElement, nextElement);
    }
    reorderAttributeTree(event) {
        if (event.attribute) {
            event.attribute = event.attribute.toJSON();
        }
        return this._fsAttributeConfig.reorderAttributeTree(event);
    }
    sortByAttributeTree(data) {
        return this._fsAttributeConfig.sortByAttributeTree(data);
    }
    getConfig(name) {
        if (this._configs.has(name)) {
            return this._configs.get(name);
        }
        else {
            throw new Error(`Configuration with class "${name}" can not be found. Please check your configs.`);
        }
    }
    _initConfigs(configs = [], mappings) {
        configs.forEach((config) => {
            const configItem = new AttributeConfigItem(config, mappings);
            this._configs.set(configItem.klass, configItem);
        });
        this._configs.forEach((configItem) => {
            if (!!configItem.childClass) {
                const child = this.getConfig(configItem.childClass);
                configItem.child = child;
                child.parent = configItem;
            }
        });
    }
    ;
}
AttributesConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AttributesConfig, deps: [{ token: FS_ATTRIBUTE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
AttributesConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AttributesConfig });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AttributesConfig, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_ATTRIBUTE_CONFIG]
                }] }]; } });

function getRawAttributeValue(value) {
    if (value) {
        if (value instanceof AttributeItem) {
            return value.toJSON();
        }
        else {
            return value;
        }
    }
    return null;
}

class FsAttributeSelectComponent {
    constructor(attributesConfig, _cdRef) {
        this.attributesConfig = attributesConfig;
        this._cdRef = _cdRef;
        this.required = false;
        this.disabled = false;
        this.noneOption = false;
        this.attributes = [];
        this.onChange = () => { };
        this.onTouch = () => { };
        this._destroy$ = new Subject();
        this.compare = (o1, o2) => {
            return this.attributesConfig.compareAttributes(o1, o2);
        };
    }
    set class(value) {
        this.klass = value;
        this.attributeConfig = this.attributesConfig.getConfig(value);
        if (this.attributeConfig) {
            this.attributeName = this.attributeConfig.name;
            this.fetch();
        }
    }
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            const data = this._getRawValue();
            this.onChange(data);
            this.onTouch(data);
        }
    }
    get value() {
        return this._value;
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    writeValue(value) {
        if (value !== this.value) {
            this._value = value
                ? new AttributeItem(value, this.attributesConfig)
                : value;
            this._cdRef.markForCheck();
        }
    }
    fetch() {
        const e = {
            data: this.data,
            class: this.klass,
            queryConfigs: this.queryConfigs,
        };
        this.attributesConfig.getAttributes(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            this._cdRef.markForCheck();
        });
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouch = fn; }
    _getRawValue() {
        return (this.value instanceof AttributeItem)
            ? this.value.toJSON()
            : this.value;
    }
}
FsAttributeSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectComponent, deps: [{ token: AttributesConfig }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeSelectComponent, selector: "fs-attribute-select", inputs: { data: "data", class: "class", label: "label", required: "required", disabled: "disabled", noneOption: "noneOption", queryConfigs: "queryConfigs" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsAttributeSelectComponent),
            multi: true
        }], ngImport: i0, template: "<mat-form-field>\n  <mat-label>\n    {{ label || attributeName }}\n  </mat-label>\n  <mat-select\n      [(ngModel)]=\"value\"\n      [required]=\"required\"\n      [disabled]=\"disabled\"\n      [compareWith]=\"compare\">\n    <mat-option [value]=\"null\" *ngIf=\"noneOption\">None</mat-option>\n    <mat-option *ngFor=\"let attribute of attributes\" [value]=\"attribute\">\n      <div class=\"option\">\n        <img *ngIf=\"attribute.image\" [src]=\"attribute.image\" alt=\"\">\n        <div>{{attribute.name}}</div>\n      </div>\n    </mat-option>\n  </mat-select>\n</mat-form-field>\n", styles: ["img{height:28px;border-radius:50%;object-fit:cover;width:28px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i3.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i1.MatLabel, selector: "mat-label" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormRequiredDirective, selector: "[fsFormRequired],[ngModel][required]", inputs: ["fsFormRequired", "required", "fsFormRequiredMessage"] }, { type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-select', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsAttributeSelectComponent),
                            multi: true
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-form-field>\n  <mat-label>\n    {{ label || attributeName }}\n  </mat-label>\n  <mat-select\n      [(ngModel)]=\"value\"\n      [required]=\"required\"\n      [disabled]=\"disabled\"\n      [compareWith]=\"compare\">\n    <mat-option [value]=\"null\" *ngIf=\"noneOption\">None</mat-option>\n    <mat-option *ngFor=\"let attribute of attributes\" [value]=\"attribute\">\n      <div class=\"option\">\n        <img *ngIf=\"attribute.image\" [src]=\"attribute.image\" alt=\"\">\n        <div>{{attribute.name}}</div>\n      </div>\n    </mat-option>\n  </mat-select>\n</mat-form-field>\n", styles: ["img{height:28px;border-radius:50%;object-fit:cover;width:28px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], class: [{
                type: Input
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], noneOption: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }] } });

class FsAttributeComponentWrapperComponent {
    constructor(_injector) {
        this._injector = _injector;
    }
    ngOnInit() {
        this.customInjector = Injector.create({
            providers: [
                {
                    provide: FS_ATTRIBUTE_FIELD_DATA,
                    useValue: {
                        field: this.field,
                        attribute: this.data,
                    },
                }
            ],
            parent: this._injector
        });
    }
}
FsAttributeComponentWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeComponentWrapperComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeComponentWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeComponentWrapperComponent, selector: "fs-attribute-component-wrapper", inputs: { field: "field", data: "data", component: "component" }, ngImport: i0, template: `<ng-container *ngComponentOutlet="component; injector: customInjector"></ng-container>`, isInline: true, directives: [{ type: i5.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModuleFactory"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeComponentWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-attribute-component-wrapper',
                    template: `<ng-container *ngComponentOutlet="component; injector: customInjector"></ng-container>`,
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { field: [{
                type: Input
            }], data: [{
                type: Input
            }], component: [{
                type: Input
            }] } });

class FsAttributeEditComponent {
    constructor(attributesConfig, data, dialogRef, _cd) {
        this.attributesConfig = attributesConfig;
        this.data = data;
        this.dialogRef = dialogRef;
        this._cd = _cd;
        this.saving = false;
        this.inEditMode = false;
        this.submitButton = null;
        this._destroy$ = new Subject();
        const attribute = this.data.attribute;
        this.attribute = attribute && cloneDeep(attribute) || {};
        if (this.data.parent) {
            this.selectedParent = new AttributeItem(this.data.parent, attributesConfig);
        }
        this.inEditMode = this.data.mode === 'edit';
        this.parentSelector = this.data.selectParent;
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.data.klass);
        if (!this.inEditMode && this.attributeConfig.backgroundColor && !this.attribute.backgroundColor) {
            this.attribute.backgroundColor = randomColor();
        }
    }
    selectImage(file) {
        const e = {
            attribute: this.attribute,
            class: this.data.klass,
            data: this.data.data,
            file: file,
            queryConfigs: this.data?.queryConfigs,
        };
        this.saving = true;
        this.attributesConfig.saveAttributeImage(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.submitButton.disabled = false;
            // TAD-T527 prevent loss config object link (was passed into attribute component wrapper
            if (Array.isArray(response.configs)) {
                delete response.configs;
            }
            // FIXME
            // Save link
            const configs = this.attribute.configs;
            const attribute = merge(response, this.attribute.toJSON());
            this.attribute = new AttributeItem(attribute, this.attributesConfig);
            // restore link
            this.attribute.configs = configs;
        }, () => { }, () => {
            this.saving = false;
            this._cd.markForCheck();
        });
    }
    save() {
        // const mapping = this.fsAttributeConfig.mapping;
        //
        // this.attribute[mapping.name] = this.name;
        // this.attribute[mapping.backgroundColor] = this.backgroundColor;
        this.saveAttribute();
    }
    saveAttribute() {
        const parent = getRawAttributeValue(this.selectedParent);
        const eventData = {
            attribute: this.attribute,
            class: this.data.klass,
            data: this.data.data,
            parent: parent,
            queryConfigs: this.data?.queryConfigs,
        };
        this.attributesConfig.saveAttribute(eventData)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            response.parent = this.selectedParent;
            this.close(response);
        });
    }
    close(data = null) {
        this.dialogRef.close(data);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsAttributeEditComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeEditComponent, deps: [{ token: AttributesConfig }, { token: MAT_DIALOG_DATA }, { token: i2.MatDialogRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeEditComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeEditComponent, selector: "ng-component", viewQueries: [{ propertyName: "submitButton", first: true, predicate: ["submitButton"], descendants: true }], ngImport: i0, template: "<form (fsForm)=\"save()\">\n  <div mat-dialog-title>{{ inEditMode ? 'Edit' : 'Create'}} {{attributeConfig?.name}}</div>\n  <mat-dialog-content>\n    <div class=\"fields\">\n\n      <fs-file-image-picker\n        (select)=\"selectImage($event)\"\n        [url]=\"attribute.image\"\n        [imageQuality]=\".8\"\n        imageWidth=\"500\"\n        imageHeight=\"500\"\n        [previewDiameter]=\"75\"\n        label=\"Image\"\n        *ngIf=\"attributeConfig?.hasEditableImage\">\n      </fs-file-image-picker>\n\n      <mat-form-field>\n        <mat-label>Name</mat-label>\n        <input matInput [(ngModel)]=\"attribute.name\" [required]=\"true\" name=\"name\">\n      </mat-form-field>\n\n      <fs-attribute-select *ngIf=\"parentSelector\"\n                           name=\"parent\"\n                           [class]=\"parentSelector\"\n                           [required]=\"true\"\n                           [(ngModel)]=\"selectedParent\"\n      >\n      </fs-attribute-select>\n\n      <mat-form-field *ngIf=\"attributeConfig.backgroundColor\">\n        <mat-label>Color</mat-label>\n        <input matInput fsColorPicker [(ngModel)]=\"attribute.backgroundColor\" name=\"color\">\n      </mat-form-field>\n\n      <ng-container *ngFor=\"let field of attributeConfig.fields\">\n        <fs-attribute-component-wrapper [field]=\"field\" [data]=\"attribute\" [component]=\"field.editComponent\"></fs-attribute-component-wrapper>\n      </ng-container>\n    </div>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button color=\"primary\" [disabled]=\"saving\" #submitButton>{{ inEditMode ? 'Save' : 'Create'}}</button>\n    <button mat-button (click)=\"close()\" type=\"button\">Cancel</button>\n  </mat-dialog-actions>\n</form>\n", styles: [".fields{display:flex;flex-direction:column}:host ::ng-deep fs-attribute-component-wrapper:last-child fs-label-field{min-height:inherit}\n"], components: [{ type: i3$2.FsFileImagePickerComponent, selector: "fs-file-image-picker", inputs: ["imageQuality", "borderRadius", "imageWidth", "imageHeight", "previewDiameter", "previewFit", "label", "minWidth", "minHeight", "disabled", "url"], outputs: ["select", "error", "selectUrl"] }, { type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: FsAttributeSelectComponent, selector: "fs-attribute-select", inputs: ["data", "class", "label", "required", "disabled", "noneOption", "queryConfigs"] }, { type: i6.FsColorPickerComponent, selector: "[fsColorPicker]", inputs: ["showClear"] }, { type: FsAttributeComponentWrapperComponent, selector: "fs-attribute-component-wrapper", inputs: ["field", "data", "component"] }, { type: i3$3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i10.FsFormDirective, selector: "[fsForm]", inputs: ["wrapperSelector", "messageSelector", "hintSelector", "labelSelector", "autocomplete", "shortcuts", "confirm", "confirmDialog", "confirmDrawer", "confirmBrowser", "confirmTabs", "dirtySubmitButton", "submit", "successDelay", "errorDelay", "tabGroup", "deactivationGuard"], outputs: ["fsForm", "invalid", "valid", "submitted", "reseted", "cleared"], exportAs: ["fsForm"] }, { type: i2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.MatLabel, selector: "mat-label" }, { type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormRequiredDirective, selector: "[fsFormRequired],[ngModel][required]", inputs: ["fsFormRequired", "required", "fsFormRequiredMessage"] }, { type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i10.FsFormNoFsValidatorsDirective, selector: "[ngModel]:not([required]):not([fsFormRequired]):not([fsFormCompare]):not([fsFormDateRange]):not([fsFormEmail]):not([fsFormEmails]):not([fsFormFunction]):not([fsFormGreater]):not([fsFormInteger]):not([fsFormLesser]):not([fsFormMax]):not([fsFormMaxLength]):not([fsFormMin]):not([fsFormMinLength]):not([fsFormNumeric]):not([fsFormPattern]):not([fsFormPhone]):not([fsFormUrl]):not([validate])" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i10.FsButtonDirective, selector: "[mat-raised-button],[mat-button],[mat-flat-button],[mat-stroked-button]", inputs: ["name", "dirtySubmit", "form"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeEditComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<form (fsForm)=\"save()\">\n  <div mat-dialog-title>{{ inEditMode ? 'Edit' : 'Create'}} {{attributeConfig?.name}}</div>\n  <mat-dialog-content>\n    <div class=\"fields\">\n\n      <fs-file-image-picker\n        (select)=\"selectImage($event)\"\n        [url]=\"attribute.image\"\n        [imageQuality]=\".8\"\n        imageWidth=\"500\"\n        imageHeight=\"500\"\n        [previewDiameter]=\"75\"\n        label=\"Image\"\n        *ngIf=\"attributeConfig?.hasEditableImage\">\n      </fs-file-image-picker>\n\n      <mat-form-field>\n        <mat-label>Name</mat-label>\n        <input matInput [(ngModel)]=\"attribute.name\" [required]=\"true\" name=\"name\">\n      </mat-form-field>\n\n      <fs-attribute-select *ngIf=\"parentSelector\"\n                           name=\"parent\"\n                           [class]=\"parentSelector\"\n                           [required]=\"true\"\n                           [(ngModel)]=\"selectedParent\"\n      >\n      </fs-attribute-select>\n\n      <mat-form-field *ngIf=\"attributeConfig.backgroundColor\">\n        <mat-label>Color</mat-label>\n        <input matInput fsColorPicker [(ngModel)]=\"attribute.backgroundColor\" name=\"color\">\n      </mat-form-field>\n\n      <ng-container *ngFor=\"let field of attributeConfig.fields\">\n        <fs-attribute-component-wrapper [field]=\"field\" [data]=\"attribute\" [component]=\"field.editComponent\"></fs-attribute-component-wrapper>\n      </ng-container>\n    </div>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button color=\"primary\" [disabled]=\"saving\" #submitButton>{{ inEditMode ? 'Save' : 'Create'}}</button>\n    <button mat-button (click)=\"close()\" type=\"button\">Cancel</button>\n  </mat-dialog-actions>\n</form>\n", styles: [".fields{display:flex;flex-direction:column}:host ::ng-deep fs-attribute-component-wrapper:last-child fs-label-field{min-height:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.MatDialogRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { submitButton: [{
                type: ViewChild,
                args: ['submitButton']
            }] } });

class FsAttributeService {
    constructor(_dialog, attributesConfig) {
        this._dialog = _dialog;
        this.attributesConfig = attributesConfig;
    }
    createAttribute(klass, config = {}) {
        return this._dialog.open(FsAttributeEditComponent, {
            data: {
                attribute: new AttributeItem({ class: klass }, this.attributesConfig),
                klass: klass,
                data: config.data,
                mode: 'create',
                queryConfigs: config.queryConfigs,
            },
            panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${klass}`],
        });
    }
}
FsAttributeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeService, deps: [{ token: i2.MatDialog }, { token: AttributesConfig }], target: i0.ɵɵFactoryTarget.Injectable });
FsAttributeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i2.MatDialog }, { type: AttributesConfig }]; } });

class FsAttributeComponent {
    constructor(_attributesConfig) {
        this._attributesConfig = _attributesConfig;
        this.hostClass = '';
        this.config = { background: true, color: true, image: true };
        this.klass = '';
        this.selectedToggled = new EventEmitter();
    }
    set attribute(value) {
        if (value instanceof AttributeItem) {
            this._attribute = value;
        }
        else {
            this._attribute = new AttributeItem(value, this._attributesConfig);
        }
    }
    get attribute() {
        return this._attribute;
    }
    ngOnInit() {
        const config = this._attributesConfig.getConfig(this.klass);
        this.hostClass = 'fs-attribute fs-attribute-' + this.klass;
        if (config) {
            this.config = config;
        }
    }
}
FsAttributeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeComponent, deps: [{ token: AttributesConfig }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeComponent, selector: "fs-attribute", inputs: { config: "config", removable: "removable", selectable: "selectable", size: "size", selected: "selected", attribute: "attribute", klass: ["class", "klass"] }, outputs: { selectedToggled: "selectedToggled" }, host: { properties: { "class": "this.hostClass" } }, ngImport: i0, template: "<fs-chip\n  [removable]=\"removable\"\n  [selectable]=\"selectable\"\n  [selected]=\"selected\"\n  [backgroundColor]=\"attribute?.backgroundColor\"\n  [color]=\"attribute?.color\"\n  [image]=\"attribute?.image\"\n  [size]=\"size\"\n  (selectedToggled)=\"selectedToggled.emit($event)\"\n  [value]=\"attribute\">\n  <ng-content></ng-content>\n</fs-chip>\n", styles: [":host{display:inline-flex}\n"], components: [{ type: i5$1.FsChipComponent, selector: "fs-chip", inputs: ["size", "value", "backgroundColor", "borderColor", "color", "outlined", "removable", "selectable", "selected", "image"], outputs: ["selectedToggled", "removed"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute', template: "<fs-chip\n  [removable]=\"removable\"\n  [selectable]=\"selectable\"\n  [selected]=\"selected\"\n  [backgroundColor]=\"attribute?.backgroundColor\"\n  [color]=\"attribute?.color\"\n  [image]=\"attribute?.image\"\n  [size]=\"size\"\n  (selectedToggled)=\"selectedToggled.emit($event)\"\n  [value]=\"attribute\">\n  <ng-content></ng-content>\n</fs-chip>\n", styles: [":host{display:inline-flex}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }]; }, propDecorators: { hostClass: [{
                type: HostBinding,
                args: ['class']
            }], config: [{
                type: Input
            }], removable: [{
                type: Input
            }], selectable: [{
                type: Input
            }], size: [{
                type: Input
            }], selected: [{
                type: Input
            }], attribute: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], selectedToggled: [{
                type: Output
            }] } });

class FsAttributeListComponent {
    constructor(attributeService, attributesConfig, dialog, cdRef, dialogData) {
        this.attributeService = attributeService;
        this.attributesConfig = attributesConfig;
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.dialogData = dialogData;
        this.actions = [];
        this.queryParam = null;
        // public listItems
        this.attributeConfig = null;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.klass = this.dialogData?.klass || this.klass;
        this.data = this.dialogData?.data || this.data;
        this.queryConfigs = this.dialogData?.queryConfigs || this.queryConfigs;
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        this._setListConfig();
    }
    edit(attribute) {
        const dialogRef = this.dialog.open(FsAttributeEditComponent, {
            data: {
                attribute: attribute,
                klass: this.klass,
                data: this.data,
                mode: 'edit',
                queryConfigs: this.queryConfigs,
            },
            panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${this.klass}`],
        });
        dialogRef.afterClosed()
            .pipe(filter((response) => !!response))
            .subscribe((response) => {
            const attr = new AttributeItem(response.attribute, attribute.attributesConfig);
            this.list.replaceRow(attr, (listRow) => listRow.id === attribute.id);
            this.cdRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _setListConfig() {
        const config = {
            paging: {
                limits: [50, 100, 200, 500, 1000]
            },
            filters: [
                {
                    name: 'keyword',
                    type: ItemType.Keyword,
                    label: 'Search'
                }
            ],
            actions: [
                ...this.actions,
                {
                    label: 'Create',
                    click: () => this._createActionClick()
                }
            ],
            rowActions: [
                {
                    click: (row, event) => {
                        return this._deleteRow(row);
                    },
                    remove: true,
                    label: 'Remove'
                }
            ],
            fetch: (query) => {
                if (this.attributeConfig.order == 2 /* Alphabetical */) {
                    query.order = 'name,asc';
                }
                else if (this.attributeConfig.order == 1 /* Custom */) {
                    query.order = 'order,asc';
                }
                const e = {
                    query: query,
                    data: this.data,
                    class: this.klass,
                    queryConfigs: this.queryConfigs,
                };
                return this.attributesConfig.getAttributes(e)
                    .pipe(map((response) => ({ data: response.data, paging: response.paging })));
            }
        };
        if (this.attributeConfig.order === 1 /* Custom */) {
            config.reorder = {
                done: (data) => {
                    const e = {
                        attributes: data,
                        data: this.data,
                        class: this.klass,
                        queryConfigs: this.queryConfigs,
                    };
                    this.attributesConfig.reorderAttributes(e)
                        .pipe(takeUntil(this._destroy$))
                        .subscribe(() => {
                    });
                }
            };
        }
        if (this.queryParam !== null) {
            config.queryParam = this.queryParam;
        }
        this.listConfig = config;
    }
    /**
     * Biggest cratch in the world. Let's remove it in new future
     */
    _deleteRow(row) {
        return new Observable((obs) => {
            this.attributesConfig.deleteConfirmation(row)
                .pipe(takeUntil(this._destroy$))
                .subscribe({
                next: () => {
                    this.attributesConfig.deleteAttribute(row).subscribe(() => {
                        obs.next();
                    });
                },
                error: () => { },
            });
        });
    }
    _createActionClick() {
        const dialogRef = this.attributeService.createAttribute(this.klass, {
            data: this.data,
            queryConfigs: this.queryConfigs,
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this.list.reload();
        });
    }
}
FsAttributeListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeListComponent, deps: [{ token: FsAttributeService }, { token: AttributesConfig }, { token: i2.MatDialog }, { token: i0.ChangeDetectorRef }, { token: MAT_DIALOG_DATA, optional: true }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeListComponent, selector: "fs-attribute-list", inputs: { klass: ["class", "klass"], actions: "actions", data: "data", size: "size", queryConfigs: "queryConfigs", queryParam: "queryParam" }, queries: [{ propertyName: "columnTemplate", first: true, predicate: FsAttributeListColumnDirective, descendants: true, read: TemplateRef }], viewQueries: [{ propertyName: "list", first: true, predicate: ["list"], descendants: true, static: true }], ngImport: i0, template: "<fs-list [config]=\"listConfig\" #list>\n  <fs-list-column>\n    <ng-template fs-list-header>{{attributeConfig.name}}</ng-template>\n    <ng-template fs-list-cell let-row=\"row\">\n      <div class=\"list-attribute\">\n        <fs-attribute\n          [attribute]=\"row\"\n          [class]=\"klass\"\n          [size]=\"size\"\n          (click)=\"edit(row)\"\n        >\n          <ng-container *ngIf=\"!columnTemplate; else columnTemplateRef\">\n            {{row.name}}\n          </ng-container>\n\n          <ng-template [ngTemplateOutlet]=\"columnTemplate\"\n                       [ngTemplateOutletContext]=\"{ attribute: row }\"\n                       #columnTemplateRef\n          ></ng-template>\n        </fs-attribute>\n      </div>\n    </ng-template>\n  </fs-list-column>\n\n  <ng-container *ngFor=\"let field of attributeConfig.fields\">\n    <fs-list-column *ngIf=\"field.listComponent\">\n      <ng-template fs-list-header>{{field.label}}</ng-template>\n      <ng-template fs-list-cell let-row=\"row\">\n        <fs-attribute-component-wrapper [data]=\"row\" [component]=\"field.listComponent\"></fs-attribute-component-wrapper>\n      </ng-template>\n    </fs-list-column>\n  </ng-container>\n</fs-list>\n", styles: ["::ng-deep .list-attribute .fs-chip{cursor:pointer}::ng-deep .list-attribute .fs-chip .fs-chip-content{overflow:visible;max-width:none}\n"], components: [{ type: i4$1.FsListComponent, selector: "fs-list", inputs: ["config", "loaderLines"], outputs: ["filtersReady"] }, { type: FsAttributeComponent, selector: "fs-attribute", inputs: ["config", "removable", "selectable", "size", "selected", "attribute", "class"], outputs: ["selectedToggled"] }, { type: FsAttributeComponentWrapperComponent, selector: "fs-attribute-component-wrapper", inputs: ["field", "data", "component"] }], directives: [{ type: i4$1.FsListColumnDirective, selector: "fs-list-column", inputs: ["show", "title", "name", "customize", "sortable", "sortableDefault", "direction", "align", "width", "class"] }, { type: i4$1.FsListHeaderDirective, selector: "[fs-list-header]", inputs: ["colspan", "align", "class"] }, { type: i4$1.FsListCellDirective, selector: "[fs-list-cell]", inputs: ["colspan", "align", "class"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fs-list [config]=\"listConfig\" #list>\n  <fs-list-column>\n    <ng-template fs-list-header>{{attributeConfig.name}}</ng-template>\n    <ng-template fs-list-cell let-row=\"row\">\n      <div class=\"list-attribute\">\n        <fs-attribute\n          [attribute]=\"row\"\n          [class]=\"klass\"\n          [size]=\"size\"\n          (click)=\"edit(row)\"\n        >\n          <ng-container *ngIf=\"!columnTemplate; else columnTemplateRef\">\n            {{row.name}}\n          </ng-container>\n\n          <ng-template [ngTemplateOutlet]=\"columnTemplate\"\n                       [ngTemplateOutletContext]=\"{ attribute: row }\"\n                       #columnTemplateRef\n          ></ng-template>\n        </fs-attribute>\n      </div>\n    </ng-template>\n  </fs-list-column>\n\n  <ng-container *ngFor=\"let field of attributeConfig.fields\">\n    <fs-list-column *ngIf=\"field.listComponent\">\n      <ng-template fs-list-header>{{field.label}}</ng-template>\n      <ng-template fs-list-cell let-row=\"row\">\n        <fs-attribute-component-wrapper [data]=\"row\" [component]=\"field.listComponent\"></fs-attribute-component-wrapper>\n      </ng-template>\n    </fs-list-column>\n  </ng-container>\n</fs-list>\n", styles: ["::ng-deep .list-attribute .fs-chip{cursor:pointer}::ng-deep .list-attribute .fs-chip .fs-chip-content{overflow:visible;max-width:none}\n"] }]
        }], ctorParameters: function () { return [{ type: FsAttributeService }, { type: AttributesConfig }, { type: i2.MatDialog }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { list: [{
                type: ViewChild,
                args: ['list', { static: true }]
            }], columnTemplate: [{
                type: ContentChild,
                args: [FsAttributeListColumnDirective, { read: TemplateRef }]
            }], klass: [{
                type: Input,
                args: ['class']
            }], actions: [{
                type: Input
            }], data: [{
                type: Input
            }], size: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], queryParam: [{
                type: Input
            }] } });

class FsAttributeManageComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    close() {
        this.dialogRef.close();
    }
}
FsAttributeManageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeManageComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i2.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeManageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeManageComponent, selector: "ng-component", ngImport: i0, template: "<div mat-dialog-title>Manage {{data.pluralName}}</div>\n<mat-dialog-content>\n  <fs-attribute-list\n    [class]=\"data.class\"\n    [size]=\"data.size\">\n  </fs-attribute-list>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button (click)=\"close()\" color=\"primary\" type=\"button\">Close</button>\n</mat-dialog-actions>\n", styles: [""], components: [{ type: FsAttributeListComponent, selector: "fs-attribute-list", inputs: ["class", "actions", "data", "size", "queryConfigs", "queryParam"] }, { type: i3$3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i10.FsButtonDirective, selector: "[mat-raised-button],[mat-button],[mat-flat-button],[mat-stroked-button]", inputs: ["name", "dirtySubmit", "form"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeManageComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div mat-dialog-title>Manage {{data.pluralName}}</div>\n<mat-dialog-content>\n  <fs-attribute-list\n    [class]=\"data.class\"\n    [size]=\"data.size\">\n  </fs-attribute-list>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button (click)=\"close()\" color=\"primary\" type=\"button\">Close</button>\n</mat-dialog-actions>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.MatDialogRef }]; } });

class FsAttributeAutocompleteChipsComponent {
    constructor(attributesConfig, _cdRef, _dialog) {
        this.attributesConfig = attributesConfig;
        this._cdRef = _cdRef;
        this._dialog = _dialog;
        this.staticTemplates = null;
        this.color = '';
        this.background = '';
        this.initOnClick = false;
        this.showManage = false;
        this.disabled = false;
        this.size = 'large';
        this.saveOnChange = true;
        this.multiple = true;
        this.label = 'Select...';
        this.required = false;
        this.draggable = true;
        this.onChange = () => { };
        this.onTouch = () => { };
        this._destroy$ = new Subject();
        this.fetch = (keyword) => {
            return this.attributesConfig.getAttributes({
                class: this.klass,
                data: this.data,
                keyword: keyword,
                queryConfigs: this.queryConfigs,
            })
                .pipe(map((response) => {
                return response.data;
            }), takeUntil(this._destroy$));
        };
        this.compare = (o1, o2) => {
            return this.attributesConfig.compareAttributes(o1, o2);
        };
    }
    set value(value) {
        if (value !== this._value) {
            this._value = value;
        }
    }
    get value() {
        return this._value;
    }
    change(value) {
        const data = this._getRawValue(value);
        this.onChange(data);
        this.onTouch(data);
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        if (!this.label) {
            this.label = this.attributeConfig.name;
        }
        if (!this.background && this.attributeConfig.backgroundColor) {
            this.background = this.attributeConfig.mapping.backgroundColor;
        }
        if (!this.color && this.attributeConfig.color) {
            this.color = this.attributeConfig.mapping.color;
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    writeValue(value) {
        if (value) {
            if (this.multiple) {
                this._value = Array.isArray(value) ?
                    value.map((item) => new AttributeItem(item, this.attributesConfig)) : [];
            }
            else {
                this._value = new AttributeItem(value, this.attributesConfig);
            }
        }
        else {
            this._value = null;
        }
        this._cdRef.markForCheck();
    }
    selected(item) {
        if (this.saveOnChange) {
            this.save(item.data, true);
        }
    }
    removed(item) {
        if (this.saveOnChange) {
            this.save(item.data, false);
        }
    }
    reordered(data) {
        if (this.saveOnChange) {
            this.save(data.item, false, data);
        }
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouch = fn; }
    manage() {
        this._dialog.open(FsAttributeManageComponent, {
            disableClose: true,
            data: {
                klass: this.attributeConfig.klass,
                pluralName: this.attributeConfig.pluralName,
                data: this.data,
                size: this.size,
                // queryConfigs: this.dialogData?.queryConfigs || this.queryConfigs,
            },
        })
            .afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.fetch(response?.attribute.id);
        });
    }
    staticClick(event, index) {
        const staticDirective = this.staticDirectives.toArray()[index];
        staticDirective.click.emit(event);
    }
    save(item = null, selected = false, reorder = null) {
        this.attributesConfig.attributeSelectionChanged({
            class: this.klass,
            data: this.data,
            attributes: this.value,
            selected: selected,
            reorder: reorder,
            value: item,
            queryConfigs: this.queryConfigs,
        })
            .pipe(takeUntil(this._destroy$))
            .subscribe();
    }
    _getRawValue(value) {
        let data = null;
        if (this.multiple) {
            if (Array.isArray(this.value)) {
                data = value.map((item) => {
                    return item.toJSON();
                });
            }
        }
        else {
            data = value ? value.toJSON() : null;
        }
        return data;
    }
}
FsAttributeAutocompleteChipsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteChipsComponent, deps: [{ token: AttributesConfig }, { token: i0.ChangeDetectorRef }, { token: i2.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeAutocompleteChipsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeAutocompleteChipsComponent, selector: "fs-attribute-autocomplete-chips", inputs: { color: "color", background: "background", initOnClick: "initOnClick", showManage: "showManage", disabled: "disabled", size: "size", saveOnChange: "saveOnChange", multiple: "multiple", data: "data", klass: ["class", "klass"], label: "label", required: "required", draggable: "draggable", queryConfigs: "queryConfigs" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsAttributeAutocompleteChipsComponent),
            multi: true
        }], queries: [{ propertyName: "staticTemplates", predicate: FsAttributeAutocompleteChipsStaticDirective, read: TemplateRef }, { propertyName: "staticDirectives", predicate: FsAttributeAutocompleteChipsStaticDirective }], ngImport: i0, template: "<fs-autocomplete-chips\n    [removable]=\"true\"\n    [chipBackground]=\"background\"\n    [chipColor]=\"color\"\n    [disabled]=\"disabled\"\n    [orderable]=\"draggable\"\n    [multiple]=\"multiple\"\n    [(ngModel)]=\"value\"\n    (selected)=\"selected($event)\"\n    (removed)=\"removed($event)\"\n    (reordered)=\"reordered($event)\"\n    (ngModelChange)=\"change($event)\"\n    [fetch]=\"fetch\"\n    [size]=\"size\"\n    [initOnClick]=\"initOnClick\"\n    [placeholder]=\"label\"\n    [compareWith]=\"compare\">\n  <ng-template fsAutocompleteObject let-object=\"object\">\n    <span *ngIf=\"object.parent\" class=\"parent\">{{ object.parent.name }}:</span>{{ object.name }}\n  </ng-template>\n\n  <ng-container *ngFor=\"let tmpl of staticTemplates; let i = index\">\n    <ng-template fsAutocompleteChipsStatic (click)=\"staticClick($event, i)\">\n      <ng-template [ngTemplateOutlet]=\"tmpl\"></ng-template>\n    </ng-template>\n  </ng-container>  \n  <ng-container *ngIf=\"showManage\">\n    <ng-template fsAutocompleteChipsStatic (click)=\"manage()\">\n      Manage\n    </ng-template>\n  </ng-container>\n</fs-autocomplete-chips>\n", styles: ["img{height:32px;border-radius:50%;object-fit:cover;width:32px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}.parent{margin-right:5px}\n"], components: [{ type: i3$4.FsAutocompleteChipsComponent, selector: "fs-autocomplete-chips", inputs: ["fetch", "appearance", "readonly", "size", "placeholder", "chipImage", "chipBackground", "chipColor", "chipIcon", "chipIconColor", "chipClass", "hint", "allowText", "allowObject", "delay", "validateText", "removable", "allowClear", "color", "background", "orderable", "limit", "initOnClick", "fetchOnFocus", "multiple", "confirm", "disabled", "panelWidth", "panelClass", "compareWith"], outputs: ["selected", "removed", "reordered", "clear"] }], directives: [{ type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormNoFsValidatorsDirective, selector: "[ngModel]:not([required]):not([fsFormRequired]):not([fsFormCompare]):not([fsFormDateRange]):not([fsFormEmail]):not([fsFormEmails]):not([fsFormFunction]):not([fsFormGreater]):not([fsFormInteger]):not([fsFormLesser]):not([fsFormMax]):not([fsFormMaxLength]):not([fsFormMin]):not([fsFormMinLength]):not([fsFormNumeric]):not([fsFormPattern]):not([fsFormPhone]):not([fsFormUrl]):not([validate])" }, { type: i3$4.FsAutocompleteObjectDirective, selector: "[fsAutocompleteObject],[fsAutocompleteChipsTemplate]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$4.FsAutocompleteChipsStaticDirective, selector: "[fsAutocompleteChipsStatic]", inputs: ["show", "disable"], outputs: ["click", "selected"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteChipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-autocomplete-chips', changeDetection: ChangeDetectionStrategy.OnPush, providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsAttributeAutocompleteChipsComponent),
                            multi: true
                        }], template: "<fs-autocomplete-chips\n    [removable]=\"true\"\n    [chipBackground]=\"background\"\n    [chipColor]=\"color\"\n    [disabled]=\"disabled\"\n    [orderable]=\"draggable\"\n    [multiple]=\"multiple\"\n    [(ngModel)]=\"value\"\n    (selected)=\"selected($event)\"\n    (removed)=\"removed($event)\"\n    (reordered)=\"reordered($event)\"\n    (ngModelChange)=\"change($event)\"\n    [fetch]=\"fetch\"\n    [size]=\"size\"\n    [initOnClick]=\"initOnClick\"\n    [placeholder]=\"label\"\n    [compareWith]=\"compare\">\n  <ng-template fsAutocompleteObject let-object=\"object\">\n    <span *ngIf=\"object.parent\" class=\"parent\">{{ object.parent.name }}:</span>{{ object.name }}\n  </ng-template>\n\n  <ng-container *ngFor=\"let tmpl of staticTemplates; let i = index\">\n    <ng-template fsAutocompleteChipsStatic (click)=\"staticClick($event, i)\">\n      <ng-template [ngTemplateOutlet]=\"tmpl\"></ng-template>\n    </ng-template>\n  </ng-container>  \n  <ng-container *ngIf=\"showManage\">\n    <ng-template fsAutocompleteChipsStatic (click)=\"manage()\">\n      Manage\n    </ng-template>\n  </ng-container>\n</fs-autocomplete-chips>\n", styles: ["img{height:32px;border-radius:50%;object-fit:cover;width:32px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}.parent{margin-right:5px}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i0.ChangeDetectorRef }, { type: i2.MatDialog }]; }, propDecorators: { staticTemplates: [{
                type: ContentChildren,
                args: [FsAttributeAutocompleteChipsStaticDirective, { read: TemplateRef }]
            }], staticDirectives: [{
                type: ContentChildren,
                args: [FsAttributeAutocompleteChipsStaticDirective]
            }], color: [{
                type: Input
            }], background: [{
                type: Input
            }], initOnClick: [{
                type: Input
            }], showManage: [{
                type: Input
            }], disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], saveOnChange: [{
                type: Input
            }], multiple: [{
                type: Input
            }], data: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }], draggable: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }] } });

class FsAttributeAutocompleteComponent {
    constructor(attributesConfig, _cdRef) {
        this.attributesConfig = attributesConfig;
        this._cdRef = _cdRef;
        this.staticTemplates = null;
        this.disabled = false;
        this.label = 'Select...';
        this.required = false;
        this.onChange = () => { };
        this.onTouch = () => { };
        this._destroy$ = new Subject();
        this.fetch = (keyword) => {
            return this.attributesConfig.getAttributes({
                class: this.klass,
                data: this.data,
                keyword: keyword,
                queryConfigs: this.queryConfigs,
            })
                .pipe(map((response) => {
                return response.data;
            }), takeUntil(this._destroy$));
        };
        this.displayWith = (data) => {
            const parent = data.parent ? data.parent.name + ': ' : '';
            return parent + data.name;
        };
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            const data = this.value ? this.value.toJSON() : null;
            this.onChange(data);
            this.onTouch(data);
        }
    }
    get value() {
        return this._value;
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        if (!this.label) {
            this.label = this.attributeConfig.name;
        }
    }
    ngOnChanges(changes) {
        if (changes.class) {
            this.autocomplete.data = [];
        }
    }
    writeValue(value) {
        if (value !== this.value) {
            this._value = value
                ? new AttributeItem(value, this.attributesConfig)
                : value;
            this._cdRef.markForCheck();
        }
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouch = fn; }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    staticClick(event, index) {
        // const staticDirective: FsAutocompleteStaticDirective = this.staticDirectives.toArray()[index];
        // staticDirective.click.emit(event);
    }
}
FsAttributeAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteComponent, deps: [{ token: AttributesConfig }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeAutocompleteComponent, selector: "fs-attribute-autocomplete", inputs: { data: "data", disabled: "disabled", klass: ["class", "klass"], label: "label", required: "required", queryConfigs: "queryConfigs" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsAttributeAutocompleteComponent),
            multi: true
        }], queries: [{ propertyName: "staticTemplates", predicate: FsAutocompleteStaticDirective, read: TemplateRef }, { propertyName: "staticDirectives", predicate: FsAutocompleteStaticDirective }], viewQueries: [{ propertyName: "autocomplete", first: true, predicate: FsAutocompleteComponent, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<fs-autocomplete\n  [fetch]=\"fetch\"\n  [fetchOnFocus]=\"true\"\n  [displayWith]=\"displayWith\"\n  [(ngModel)]=\"value\"\n  [placeholder]=\"label\"\n  [required]=\"required\"\n  [disabled]=\"disabled\"\n  name=\"autocomplete\">\n  <ng-template fsAutocompleteTemplate let-data=\"data\">\n    <span *ngIf=\"data.parent\" class=\"parent\">{{ data.parent.name }}:</span>{{ data.name }}\n  </ng-template>\n\n  <ng-container *ngFor=\"let tmpl of staticTemplates; let i = index\">\n    <ng-template fsAutocompleteStatic (selected)=\"staticClick($event, i)\">\n      <ng-template [ngTemplateOutlet]=\"tmpl\"></ng-template>\n    </ng-template>\n  </ng-container>\n</fs-autocomplete>\n", styles: ["img{height:32px;border-radius:50%;object-fit:cover;width:32px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}.parent{margin-right:5px}fs-autocomplete ::ng-deep .mat-form-field{display:block;width:100%}\n"], components: [{ type: i2$1.FsAutocompleteComponent, selector: "fs-autocomplete", inputs: ["fetch", "displayWith", "placeholder", "fetchOnFocus", "readonly", "required", "disabled", "formFieldClass", "appearance", "hint", "panelWidth", "panelClass", "showClear"], outputs: ["cleared", "opened", "closed"] }], directives: [{ type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormRequiredDirective, selector: "[fsFormRequired],[ngModel][required]", inputs: ["fsFormRequired", "required", "fsFormRequiredMessage"] }, { type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i2$1.FsAutocompleteTemplateDirective, selector: "[fsAutocompleteTemplate]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.FsAutocompleteStaticDirective, selector: "[fsAutocompleteStatic],[fsAutocompleteStaticTemplate]", inputs: ["show", "disable"], outputs: ["selected"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-autocomplete', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsAttributeAutocompleteComponent),
                            multi: true
                        }], template: "<fs-autocomplete\n  [fetch]=\"fetch\"\n  [fetchOnFocus]=\"true\"\n  [displayWith]=\"displayWith\"\n  [(ngModel)]=\"value\"\n  [placeholder]=\"label\"\n  [required]=\"required\"\n  [disabled]=\"disabled\"\n  name=\"autocomplete\">\n  <ng-template fsAutocompleteTemplate let-data=\"data\">\n    <span *ngIf=\"data.parent\" class=\"parent\">{{ data.parent.name }}:</span>{{ data.name }}\n  </ng-template>\n\n  <ng-container *ngFor=\"let tmpl of staticTemplates; let i = index\">\n    <ng-template fsAutocompleteStatic (selected)=\"staticClick($event, i)\">\n      <ng-template [ngTemplateOutlet]=\"tmpl\"></ng-template>\n    </ng-template>\n  </ng-container>\n</fs-autocomplete>\n", styles: ["img{height:32px;border-radius:50%;object-fit:cover;width:32px;margin-right:8px}.option{display:flex;flex-direction:row;align-items:center}.parent{margin-right:5px}fs-autocomplete ::ng-deep .mat-form-field{display:block;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { autocomplete: [{
                type: ViewChild,
                args: [FsAutocompleteComponent, { static: true }]
            }], staticTemplates: [{
                type: ContentChildren,
                args: [FsAutocompleteStaticDirective, { read: TemplateRef }]
            }], staticDirectives: [{
                type: ContentChildren,
                args: [FsAutocompleteStaticDirective]
            }], data: [{
                type: Input
            }], disabled: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }] } });

class AttributeSearchComponent {
    constructor() {
        this.placeholder = 'Search';
        this.keyword = new EventEmitter();
        this.searchText = '';
    }
    modelChange(text) {
        this.keyword.emit(text);
    }
}
AttributeSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AttributeSearchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AttributeSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AttributeSearchComponent, selector: "fs-attribute-search", inputs: { placeholder: "placeholder" }, outputs: { keyword: "keyword" }, ngImport: i0, template: "<form autocomplete=\"off\" role=\"presentation\">\n  <mat-form-field class=\"attributes-filter-input\" floatLabel=\"never\">\n    <mat-label>\n      {{placeholder}}\n    </mat-label>\n    <span matPrefix><mat-icon matPrefix>search</mat-icon></span>\n\n    <input matInput\n           [(ngModel)]=\"searchText\"\n           (ngModelChange)=\"modelChange(searchText)\"\n           name=\"attributes-filter-input\"\n    >\n  </mat-form-field>\n</form>\n", styles: ["form,form .attributes-filter-input{width:100%}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1.MatLabel, selector: "mat-label" }, { type: i1.MatPrefix, selector: "[matPrefix]" }, { type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormNoFsValidatorsDirective, selector: "[ngModel]:not([required]):not([fsFormRequired]):not([fsFormCompare]):not([fsFormDateRange]):not([fsFormEmail]):not([fsFormEmails]):not([fsFormFunction]):not([fsFormGreater]):not([fsFormInteger]):not([fsFormLesser]):not([fsFormMax]):not([fsFormMaxLength]):not([fsFormMin]):not([fsFormMinLength]):not([fsFormNumeric]):not([fsFormPattern]):not([fsFormPhone]):not([fsFormUrl]):not([validate])" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AttributeSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form autocomplete=\"off\" role=\"presentation\">\n  <mat-form-field class=\"attributes-filter-input\" floatLabel=\"never\">\n    <mat-label>\n      {{placeholder}}\n    </mat-label>\n    <span matPrefix><mat-icon matPrefix>search</mat-icon></span>\n\n    <input matInput\n           [(ngModel)]=\"searchText\"\n           (ngModelChange)=\"modelChange(searchText)\"\n           name=\"attributes-filter-input\"\n    >\n  </mat-form-field>\n</form>\n", styles: ["form,form .attributes-filter-input{width:100%}\n"] }]
        }], propDecorators: { placeholder: [{
                type: Input
            }], keyword: [{
                type: Output
            }] } });

class FsAttributeSelectorWithGroupsComponent {
    constructor(attributesConfig, el, dialog, dialogData, dialogRef, cdRef) {
        this.attributesConfig = attributesConfig;
        this.el = el;
        this.dialog = dialog;
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.cdRef = cdRef;
        this.data = {};
        this.showCreate = true;
        this.selectedAttributes = [];
        this.placeholder = 'Search';
        this.selectedToggled = new EventEmitter();
        this.hostClass = '';
        this.attributes = [];
        this.attributeConfig = null;
        this.dialogMode = false;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.dialogData && this.dialogData.class) {
            this.dialogMode = !!this.dialogData;
            this.klass = this.dialogData.class;
            this.childClass = this.dialogData.childClass;
            this.data = this.dialogData.data;
            this.selectedAttributes = this.dialogData.selectedAttributes;
            this.showCreate = this.dialogData.showCreate;
            this.initDialog();
        }
        else {
            this.hostClass = 'fs-attribute fs-attribute-' + this.klass;
            Object.assign(this.data, { childAttributes: true });
        }
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        this.compareFn = this.getCompareFn();
        this.fetch();
    }
    getCompareFn() {
        if (this.dialogData && this.dialogData.class) {
            return this.attributesConfig.compareAttributes.bind(this.attributesConfig);
        }
        else {
            return this.attributesConfig.compare.bind(this.attributesConfig);
        }
    }
    ;
    selectedToggle(event) {
        this.selectedToggled.emit({
            selected: event.selected,
            value: event.value.toJSON(),
        });
        event.data = this.data;
        event.klass = this.childClass;
        event.queryConfigs = this.queryConfigs;
        event.attribute = event.value;
        this.attributesConfig.attributeSelectionChanged(event)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
        });
    }
    done() {
        this.dialogRef.close({ attributes: this.selectedAttributes });
    }
    create() {
        const attribute = new AttributeItem({ class: this.attributeConfig.childClass }, this.attributesConfig);
        const dialogRef = this.dialog.open(FsAttributeEditComponent, {
            data: {
                attribute: attribute,
                klass: this.attributeConfig.childClass,
                selectParent: this.attributeConfig.klass,
                mode: 'create',
                queryConfigs: this.queryConfigs,
            },
            panelClass: [
                `fs-attribute-dialog`,
                `fs-attribute-dialog-no-scroll`,
                `fs-attribute-${this.attributeConfig.childClass}`
            ],
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(response => {
            this.fetch(null, {
                parentId: response?.parent.id,
                attrId: response?.attribute.id,
            });
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    initDialog() {
        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick()
            .pipe(takeUntil(this._destroy$))
            .subscribe(result => {
            this.done();
        });
    }
    /**
     *
     * @param keyword
     * @param autoSelectAttr - param which can be passed for automatically select some attr after fetch
     */
    fetch(keyword = null, autoSelectAttr = null) {
        const e = {
            query: {},
            keyword: keyword,
            class: this.klass,
            data: this.data,
            queryConfigs: this.queryConfigs,
        };
        this.attributesConfig.getAttributes(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            // We should auto select attribute after it was created
            if (autoSelectAttr) {
                const group = this.attributes
                    .find((attr) => attr.id === autoSelectAttr.parentId);
                if (group) {
                    const attribute = group.children.find((attr) => attr.id === autoSelectAttr.attrId);
                    // Add to selected attributes
                    this.selectedAttributes.push(attribute);
                    // selectedToggle method required special event object
                    const event = {
                        selected: true,
                        value: attribute
                    };
                    this.selectedToggle(event);
                }
            }
            this.cdRef.markForCheck();
        });
    }
    search(text) {
        this.fetch(text);
    }
}
FsAttributeSelectorWithGroupsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectorWithGroupsComponent, deps: [{ token: AttributesConfig }, { token: i0.ElementRef }, { token: i2.MatDialog }, { token: MAT_DIALOG_DATA, optional: true }, { token: i2.MatDialogRef, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeSelectorWithGroupsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeSelectorWithGroupsComponent, selector: "fs-attribute-selector-with-groups", inputs: { data: "data", showCreate: "showCreate", klass: ["class", "klass"], selectedAttributes: "selectedAttributes", placeholder: "placeholder", queryConfigs: "queryConfigs" }, outputs: { selectedToggled: "selectedToggled" }, host: { properties: { "class": "this.hostClass" } }, ngImport: i0, template: "<ng-container *ngIf=\"dialogMode; else groupsList\">\n  <div mat-dialog-title>Select {{attributeConfig?.child?.pluralName}}</div>\n  <mat-dialog-content>\n    <ng-template [ngTemplateOutlet]=\"groupsList\"></ng-template>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button (click)=\"done()\" color=\"primary\">Close</button>\n    <button mat-button (click)=\"create()\" *ngIf=\"showCreate!==false\">Create {{attributeConfig?.child?.name}}</button>\n  </mat-dialog-actions>\n</ng-container>\n\n\n<ng-template #groupsList>\n  <fs-attribute-search (keyword)=\"search($event)\" [placeholder]=\"placeholder\"></fs-attribute-search>\n\n  <div class=\"group-container\"\n       *ngFor=\"let attribute of attributes\"\n  >\n    <div class=\"group-heading\">\n      <img [src]=\"attribute.image\" alt=\"\" class=\"group-image\">\n      {{ attribute.name }}\n    </div>\n\n    <fs-chips\n      [(ngModel)]=\"selectedAttributes\"\n      [compare]=\"compareFn\">\n      <fs-chip\n        *ngFor=\"let childAttribute of attribute.children\"\n        [selectable]=\"true\"\n        [outlined]=\"true\"\n        [value]=\"childAttribute\"\n        (selectedToggled)=\"selectedToggle($event)\">\n        {{ childAttribute.name }}\n      </fs-chip>\n    </fs-chips>\n  </div>\n</ng-template>\n", styles: [":host ::ng-deep .fs-chip:not(.selected){opacity:.45}.group-container{border-bottom:1px solid #d4d4d4;padding-bottom:10px;margin-bottom:10px}.group-container .group-heading{display:flex;align-items:center;font-size:15px;margin-bottom:10px}.group-container .group-heading .group-image{width:40px;height:40px;border-radius:50%;margin-right:10px;object-fit:cover}\n"], components: [{ type: i3$3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: AttributeSearchComponent, selector: "fs-attribute-search", inputs: ["placeholder"], outputs: ["keyword"] }, { type: i5$1.FsChipsComponent, selector: "fs-chips", inputs: ["compare", "multiple"] }, { type: i5$1.FsChipComponent, selector: "fs-chip", inputs: ["size", "value", "backgroundColor", "borderColor", "color", "outlined", "removable", "selectable", "selected", "image"], outputs: ["selectedToggled", "removed"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i10.FsButtonDirective, selector: "[mat-raised-button],[mat-button],[mat-flat-button],[mat-stroked-button]", inputs: ["name", "dirtySubmit", "form"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormNoFsValidatorsDirective, selector: "[ngModel]:not([required]):not([fsFormRequired]):not([fsFormCompare]):not([fsFormDateRange]):not([fsFormEmail]):not([fsFormEmails]):not([fsFormFunction]):not([fsFormGreater]):not([fsFormInteger]):not([fsFormLesser]):not([fsFormMax]):not([fsFormMaxLength]):not([fsFormMin]):not([fsFormMinLength]):not([fsFormNumeric]):not([fsFormPattern]):not([fsFormPhone]):not([fsFormUrl]):not([validate])" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectorWithGroupsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-selector-with-groups', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"dialogMode; else groupsList\">\n  <div mat-dialog-title>Select {{attributeConfig?.child?.pluralName}}</div>\n  <mat-dialog-content>\n    <ng-template [ngTemplateOutlet]=\"groupsList\"></ng-template>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button (click)=\"done()\" color=\"primary\">Close</button>\n    <button mat-button (click)=\"create()\" *ngIf=\"showCreate!==false\">Create {{attributeConfig?.child?.name}}</button>\n  </mat-dialog-actions>\n</ng-container>\n\n\n<ng-template #groupsList>\n  <fs-attribute-search (keyword)=\"search($event)\" [placeholder]=\"placeholder\"></fs-attribute-search>\n\n  <div class=\"group-container\"\n       *ngFor=\"let attribute of attributes\"\n  >\n    <div class=\"group-heading\">\n      <img [src]=\"attribute.image\" alt=\"\" class=\"group-image\">\n      {{ attribute.name }}\n    </div>\n\n    <fs-chips\n      [(ngModel)]=\"selectedAttributes\"\n      [compare]=\"compareFn\">\n      <fs-chip\n        *ngFor=\"let childAttribute of attribute.children\"\n        [selectable]=\"true\"\n        [outlined]=\"true\"\n        [value]=\"childAttribute\"\n        (selectedToggled)=\"selectedToggle($event)\">\n        {{ childAttribute.name }}\n      </fs-chip>\n    </fs-chips>\n  </div>\n</ng-template>\n", styles: [":host ::ng-deep .fs-chip:not(.selected){opacity:.45}.group-container{border-bottom:1px solid #d4d4d4;padding-bottom:10px;margin-bottom:10px}.group-container .group-heading{display:flex;align-items:center;font-size:15px;margin-bottom:10px}.group-container .group-heading .group-image{width:40px;height:40px;border-radius:50%;margin-right:10px;object-fit:cover}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i0.ElementRef }, { type: i2.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }, {
                    type: Optional
                }] }, { type: i2.MatDialogRef, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], showCreate: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], selectedAttributes: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], selectedToggled: [{
                type: Output
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class FsAttributeFieldGroupsComponent {
    constructor(attributesConfig, dialog, cdRef) {
        this.attributesConfig = attributesConfig;
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.showCreate = true;
        this.changed = new EventEmitter();
        this.attributes = [];
        this.selectedAttributes = [];
        this._destroy$ = new Subject();
    }
    set heading(value) {
        this.title = value;
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        if (this.title === void 0 && this.attributeConfig.child) {
            this.title = this.attributeConfig.child.pluralName;
        }
        const e = {
            data: this.data,
            parentClass: this.klass,
            class: this.attributeConfig.childClass,
            queryConfigs: this.queryConfigs,
        };
        this.attributesConfig.getSelectedAttributes(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            this.selectedAttributes = this.attributes.reduce((acc, attribute) => {
                acc.push(attribute);
                return acc;
            }, []);
            this.cdRef.markForCheck();
        });
        this.changed
            .pipe(takeUntil(this._destroy$))
            .subscribe((attributes) => {
            this.selectedAttributes = attributes;
            this.cdRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    select() {
        const dialogRef = this.dialog.open(FsAttributeSelectorWithGroupsComponent, {
            data: {
                selectedAttributes: this.selectedAttributes.slice(),
                class: this.klass,
                childClass: this.attributeConfig.childClass,
                data: this.data,
                showCreate: this.showCreate,
                queryConfigs: this.queryConfigs,
            },
            panelClass: [`fs-attribute-dialog`, `fs-attribute-${this.klass}`],
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(response => {
            if (response && response.attributes) {
                const parentAttributeConfig = this.attributesConfig.getAttributeConfig(this.klass);
                const attributes = this.attributesConfig.sortAttributes(parentAttributeConfig.childClass, response.attributes);
                this.changed.emit(attributes);
                this.cdRef.markForCheck();
            }
        });
    }
}
FsAttributeFieldGroupsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeFieldGroupsComponent, deps: [{ token: AttributesConfig }, { token: i2.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeFieldGroupsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeFieldGroupsComponent, selector: "fs-attribute-field-groups", inputs: { data: "data", showCreate: "showCreate", klass: ["class", "klass"], queryConfigs: "queryConfigs", mode: "mode", heading: "heading" }, outputs: { changed: "changed" }, ngImport: i0, template: "<fs-label-field>\n  <fs-label *ngIf=\"title !== false\">{{ title }}</fs-label>\n  <div class=\"attributes\">\n    <fs-attribute\n      *ngFor=\"let attribute of selectedAttributes\"\n      [class]=\"klass\"\n      [attribute]=\"attribute\"\n    >\n      {{attribute.name}}\n    </fs-attribute>\n    <a (click)=\"select()\" class=\"select-button\"><small>Select</small></a>\n  </div>\n</fs-label-field>\n", styles: [":host ::ng-deep .fs-attribute,:host ::ng-deep .not-selected{margin-top:7px}:host ::ng-deep .not-selected{font-size:13px}:host ::ng-deep .fs-chip{margin-top:0}.attributes{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin-top:-7px;margin-left:-7px}.attributes .select-button{margin-top:8px;align-self:center;cursor:pointer}.attributes>*{margin-left:7px}\n"], components: [{ type: i3$5.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i3$5.FsLabelComponent, selector: "fs-label" }, { type: FsAttributeComponent, selector: "fs-attribute", inputs: ["config", "removable", "selectable", "size", "selected", "attribute", "class"], outputs: ["selectedToggled"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeFieldGroupsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-field-groups', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fs-label-field>\n  <fs-label *ngIf=\"title !== false\">{{ title }}</fs-label>\n  <div class=\"attributes\">\n    <fs-attribute\n      *ngFor=\"let attribute of selectedAttributes\"\n      [class]=\"klass\"\n      [attribute]=\"attribute\"\n    >\n      {{attribute.name}}\n    </fs-attribute>\n    <a (click)=\"select()\" class=\"select-button\"><small>Select</small></a>\n  </div>\n</fs-label-field>\n", styles: [":host ::ng-deep .fs-attribute,:host ::ng-deep .not-selected{margin-top:7px}:host ::ng-deep .not-selected{font-size:13px}:host ::ng-deep .fs-chip{margin-top:0}.attributes{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin-top:-7px;margin-left:-7px}.attributes .select-button{margin-top:8px;align-self:center;cursor:pointer}.attributes>*{margin-left:7px}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i2.MatDialog }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], showCreate: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], queryConfigs: [{
                type: Input
            }], mode: [{
                type: Input
            }], heading: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class FsAttributeSelectorComponent {
    constructor(attributesConfig, el, dialog, dialogData, dialogRef, cdRef) {
        this.attributesConfig = attributesConfig;
        this.el = el;
        this.dialog = dialog;
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.cdRef = cdRef;
        this.data = {};
        this.showManage = true;
        this.filter = false;
        this.selectedAttributes = [];
        this.selectedToggled = new EventEmitter();
        this.hostClass = '';
        this.attributes = [];
        this.filteredAttributes = [];
        this.attributeConfig = null;
        this.dialogMode = false;
        this.filterKeyword = '';
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.dialogData && this.dialogData.class) {
            this.dialogMode = !!this.dialogData;
            this.klass = this.dialogData.class;
            this.data = this.dialogData.data;
            this.size = this.dialogData.size;
            this.selectedAttributes = this.dialogData.selectedAttributes;
            this.initDialog();
        }
        else {
            this.hostClass = 'fs-attribute fs-attribute-' + this.klass;
        }
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        this.fetch();
        this.compareFn = this.getCompareFn();
    }
    getCompareFn() {
        if (this.dialogData && this.dialogData.class) {
            return this.attributesConfig.compareAttributes.bind(this.attributesConfig);
        }
        else {
            return this.attributesConfig.compare.bind(this.attributesConfig);
        }
    }
    ;
    done() {
        this.dialogRef.close({ attributes: this.selectedAttributes });
    }
    create() {
        const attribute = new AttributeItem({ class: this.attributeConfig.klass }, this.attributesConfig);
        const dialogRef = this.dialog.open(FsAttributeEditComponent, {
            data: {
                attribute: attribute,
                klass: this.attributeConfig.klass,
                config: this.dialogData && this.dialogData.config,
                data: this.data,
                mode: 'create',
                queryConfigs: this.dialogData?.queryConfigs || this.queryConfigs,
            },
            panelClass: [
                `fs-attribute-dialog`,
                `fs-attribute-dialog-no-scroll`,
                `fs-attribute-${this.attributeConfig.klass}`,
            ],
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(response => {
            this.fetch(response?.attribute.id);
        });
    }
    manage() {
        this.dialog.open(FsAttributeManageComponent, {
            disableClose: true,
            data: {
                klass: this.attributeConfig.klass,
                pluralName: this.attributeConfig.pluralName,
                data: this.data,
                size: this.size,
                queryConfigs: this.dialogData?.queryConfigs || this.queryConfigs,
            },
        })
            .afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.fetch(response?.attribute.id);
        });
    }
    selectedToggle(event) {
        this.selectedToggled.emit({
            selected: event.selected,
            value: event.value.toJSON(),
        });
        event.data = this.data;
        event.klass = this.klass;
        event.attribute = event.value;
        this.attributesConfig.attributeSelectionChanged(event)
            .pipe(takeUntil(this._destroy$))
            .subscribe((e) => { });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    filterByKeyword() {
        if (this.filterKeyword === '') {
            this.filteredAttributes = this.attributes.slice();
        }
        else {
            this.filteredAttributes = this.attributes.filter((attribute) => {
                const name = attribute.name.toString().toLowerCase();
                return name.indexOf(this.filterKeyword.toLowerCase()) > -1;
            });
        }
    }
    fetch(attributeId = null) {
        const e = {
            query: {},
            class: this.klass,
            data: this.data,
            queryConfigs: this.dialogData?.queryConfigs || this.queryConfigs
        };
        this.attributesConfig.getAttributes(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            this.filteredAttributes = this.attributes.slice();
            this.selectedAttributes = this.selectedAttributes
                .map((selectedAttribute) => {
                const newAttribute = this.attributes
                    .find((attr) => attr.id === selectedAttribute.id);
                return newAttribute ?? selectedAttribute;
            });
            if (attributeId) {
                const attribute = this.attributes
                    .find((attr) => attr.id === attributeId);
                // Add to selected attributes
                this.selectedAttributes.push(attribute);
                // selectedToggle method required special event object
                const event = {
                    selected: true,
                    value: attribute
                };
                this.selectedToggle(event);
            }
            this.cdRef.markForCheck();
        });
    }
    initDialog() {
        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick().subscribe((result) => {
            this.done();
        });
    }
}
FsAttributeSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectorComponent, deps: [{ token: AttributesConfig }, { token: i0.ElementRef }, { token: i2.MatDialog }, { token: MAT_DIALOG_DATA, optional: true }, { token: i2.MatDialogRef, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeSelectorComponent, selector: "fs-attribute-selector", inputs: { data: "data", showManage: "showManage", klass: ["class", "klass"], placeholder: "placeholder", filter: "filter", selectedAttributes: "selectedAttributes", queryConfigs: "queryConfigs", size: "size" }, outputs: { selectedToggled: "selectedToggled" }, host: { properties: { "class": "this.hostClass" } }, ngImport: i0, template: "<ng-container *ngIf=\"dialogMode; else chipsList\">\n  <fs-dialog>\n    <div mat-dialog-title>{{attributeConfig.pluralName}}</div>\n    <div mat-dialog-content>\n      <ng-template [ngTemplateOutlet]=\"chipsList\"></ng-template>\n    </div>\n    <div mat-dialog-actions>\n      <button mat-button (click)=\"done()\" color=\"primary\">Close</button>\n      <button mat-button (click)=\"manage()\" *ngIf=\"showManage !== false\">Manage</button>\n    </div>\n  </fs-dialog>\n</ng-container>\n\n<ng-template #chipsList>\n  <mat-form-field class=\"search-attribute\" *ngIf=\"filter\">\n    <mat-label>\n      {{placeholder}}\n    </mat-label>\n    <mat-icon matPrefix>search</mat-icon>\n    <div>\n      <input type=\"text\" matInput\n             [(ngModel)]=\"filterKeyword\"\n             (ngModelChange)=\"filterByKeyword()\">\n    </div>\n  </mat-form-field>\n\n  <fs-chips\n      [(ngModel)]=\"selectedAttributes\"\n      [compare]=\"compareFn\">\n    <fs-chip\n        [size]=\"size\"\n        *ngFor=\"let attribute of filteredAttributes\"\n        [selectable]=\"true\"\n        [image]=\"attribute.image\"\n        [backgroundColor]=\"attribute.backgroundColor\"\n        [value]=\"attribute\"\n        (selectedToggled)=\"selectedToggle($event)\">\n      {{ attribute.name }}\n    </fs-chip>\n  </fs-chips>\n</ng-template>\n", styles: [":host ::ng-deep .fs-chip:not(.selected){opacity:.45}:host ::ng-deep .mat-dialog-actions .mat-button{white-space:pre-line;text-align:left}fs-chips{overflow:hidden}.search-attribute{width:100%}.mat-dialog-actions .mat-button{margin-left:0}\n"], components: [{ type: i3$6.FsDialogComponent, selector: "fs-dialog", inputs: ["mobileMode", "mobileButtonPlacement", "mobileWidth", "mode", "buttonLayout"] }, { type: i3$3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i5$1.FsChipsComponent, selector: "fs-chips", inputs: ["compare", "multiple"] }, { type: i5$1.FsChipComponent, selector: "fs-chip", inputs: ["size", "value", "backgroundColor", "borderColor", "color", "outlined", "removable", "selectable", "selected", "image"], outputs: ["selectedToggled", "removed"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i10.FsButtonDirective, selector: "[mat-raised-button],[mat-button],[mat-flat-button],[mat-stroked-button]", inputs: ["name", "dirtySubmit", "form"] }, { type: i1.MatLabel, selector: "mat-label" }, { type: i1.MatPrefix, selector: "[matPrefix]" }, { type: i12.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i10.FsFormNoFsValidatorsDirective, selector: "[ngModel]:not([required]):not([fsFormRequired]):not([fsFormCompare]):not([fsFormDateRange]):not([fsFormEmail]):not([fsFormEmails]):not([fsFormFunction]):not([fsFormGreater]):not([fsFormInteger]):not([fsFormLesser]):not([fsFormMax]):not([fsFormMaxLength]):not([fsFormMin]):not([fsFormMinLength]):not([fsFormNumeric]):not([fsFormPattern]):not([fsFormPhone]):not([fsFormUrl]):not([validate])" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"dialogMode; else chipsList\">\n  <fs-dialog>\n    <div mat-dialog-title>{{attributeConfig.pluralName}}</div>\n    <div mat-dialog-content>\n      <ng-template [ngTemplateOutlet]=\"chipsList\"></ng-template>\n    </div>\n    <div mat-dialog-actions>\n      <button mat-button (click)=\"done()\" color=\"primary\">Close</button>\n      <button mat-button (click)=\"manage()\" *ngIf=\"showManage !== false\">Manage</button>\n    </div>\n  </fs-dialog>\n</ng-container>\n\n<ng-template #chipsList>\n  <mat-form-field class=\"search-attribute\" *ngIf=\"filter\">\n    <mat-label>\n      {{placeholder}}\n    </mat-label>\n    <mat-icon matPrefix>search</mat-icon>\n    <div>\n      <input type=\"text\" matInput\n             [(ngModel)]=\"filterKeyword\"\n             (ngModelChange)=\"filterByKeyword()\">\n    </div>\n  </mat-form-field>\n\n  <fs-chips\n      [(ngModel)]=\"selectedAttributes\"\n      [compare]=\"compareFn\">\n    <fs-chip\n        [size]=\"size\"\n        *ngFor=\"let attribute of filteredAttributes\"\n        [selectable]=\"true\"\n        [image]=\"attribute.image\"\n        [backgroundColor]=\"attribute.backgroundColor\"\n        [value]=\"attribute\"\n        (selectedToggled)=\"selectedToggle($event)\">\n      {{ attribute.name }}\n    </fs-chip>\n  </fs-chips>\n</ng-template>\n", styles: [":host ::ng-deep .fs-chip:not(.selected){opacity:.45}:host ::ng-deep .mat-dialog-actions .mat-button{white-space:pre-line;text-align:left}fs-chips{overflow:hidden}.search-attribute{width:100%}.mat-dialog-actions .mat-button{margin-left:0}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i0.ElementRef }, { type: i2.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }, {
                    type: Optional
                }] }, { type: i2.MatDialogRef, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], showManage: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], placeholder: [{
                type: Input
            }], filter: [{
                type: Input
            }], selectedAttributes: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], size: [{
                type: Input
            }], selectedToggled: [{
                type: Output
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class FsAttributeFieldComponent {
    constructor(attributesConfig, dialog, fsAttributeConfig, _cdRef) {
        this.attributesConfig = attributesConfig;
        this.dialog = dialog;
        this.fsAttributeConfig = fsAttributeConfig;
        this._cdRef = _cdRef;
        this.showCreate = true;
        this.showSelect = true;
        this.changed = new EventEmitter();
        this.attributes = [];
        this.destroy$ = new Subject();
    }
    set heading(value) {
        this.label = value;
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        if (this.label === void 0) {
            this.label = this.attributeConfig.pluralName;
        }
        this.fetch();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    fetch() {
        const e = {
            data: this.data,
            class: this.klass,
            queryConfigs: this.queryConfigs,
        };
        this.attributesConfig.getSelectedAttributes(e)
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            this._cdRef.markForCheck();
        });
    }
    select() {
        this.dialog.open(FsAttributeSelectorComponent, {
            data: {
                selectedAttributes: this.attributes.slice(),
                class: this.klass,
                data: this.data,
                size: this.size,
                showCreate: this.showCreate,
                queryConfigs: this.queryConfigs,
            },
            panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${this.klass}`],
        })
            .afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
            if (response && response.attributes) {
                this.attributes = this.attributesConfig.sortAttributes(this.klass, response.attributes);
                this.changed.emit(this.attributes);
                this._cdRef.markForCheck();
            }
        });
    }
}
FsAttributeFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeFieldComponent, deps: [{ token: AttributesConfig }, { token: i2.MatDialog }, { token: FS_ATTRIBUTE_CONFIG }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeFieldComponent, selector: "fs-attribute-field", inputs: { data: "data", showCreate: "showCreate", showSelect: "showSelect", heading: "heading", klass: ["class", "klass"], label: "label", size: "size", queryConfigs: "queryConfigs" }, outputs: { changed: "changed" }, queries: [{ propertyName: "templ", first: true, predicate: FsAttributeTemplateDirective, descendants: true, read: TemplateRef }], ngImport: i0, template: "<fs-label-field *ngIf=\"label; else attribs\">\n  <fs-label *ngIf=\"label\">{{label}}</fs-label>\n  <ng-container *ngTemplateOutlet=\"attribs\"></ng-container>\n</fs-label-field>\n\n<ng-template #attribs>\n  <div class=\"attributes\">\n    <fs-attribute\n        *ngFor=\"let attribute of attributes\"\n        [class]=\"klass\"\n        [size]=\"size\"\n        [attribute]=\"attribute\">\n      <ng-template\n        [ngTemplateOutlet]=\"templ || defaultNodeTemplate\"\n        [ngTemplateOutletContext]=\"{ attribute: attribute }\"\n      ></ng-template>\n    </fs-attribute>\n    <a *ngIf=\"showSelect\" (click)=\"select()\" class=\"select-button\"><small>Select</small></a>\n  </div>\n</ng-template>\n\n<ng-template #defaultNodeTemplate let-attribute=\"attribute\">\n  {{ attribute.name }}\n</ng-template>\n", styles: [":host ::ng-deep .fs-attribute,:host ::ng-deep .not-selected{margin-top:7px}:host ::ng-deep .not-selected{font-size:13px}:host ::ng-deep .fs-chip{margin-top:0}.attributes{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin-top:-7px;margin-left:-7px}.attributes .select-button{margin-top:8px;align-self:center;cursor:pointer}.attributes>*{margin-left:7px}\n"], components: [{ type: i3$5.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i3$5.FsLabelComponent, selector: "fs-label" }, { type: FsAttributeComponent, selector: "fs-attribute", inputs: ["config", "removable", "selectable", "size", "selected", "attribute", "class"], outputs: ["selectedToggled"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-field', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fs-label-field *ngIf=\"label; else attribs\">\n  <fs-label *ngIf=\"label\">{{label}}</fs-label>\n  <ng-container *ngTemplateOutlet=\"attribs\"></ng-container>\n</fs-label-field>\n\n<ng-template #attribs>\n  <div class=\"attributes\">\n    <fs-attribute\n        *ngFor=\"let attribute of attributes\"\n        [class]=\"klass\"\n        [size]=\"size\"\n        [attribute]=\"attribute\">\n      <ng-template\n        [ngTemplateOutlet]=\"templ || defaultNodeTemplate\"\n        [ngTemplateOutletContext]=\"{ attribute: attribute }\"\n      ></ng-template>\n    </fs-attribute>\n    <a *ngIf=\"showSelect\" (click)=\"select()\" class=\"select-button\"><small>Select</small></a>\n  </div>\n</ng-template>\n\n<ng-template #defaultNodeTemplate let-attribute=\"attribute\">\n  {{ attribute.name }}\n</ng-template>\n", styles: [":host ::ng-deep .fs-attribute,:host ::ng-deep .not-selected{margin-top:7px}:host ::ng-deep .not-selected{font-size:13px}:host ::ng-deep .fs-chip{margin-top:0}.attributes{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin-top:-7px;margin-left:-7px}.attributes .select-button{margin-top:8px;align-self:center;cursor:pointer}.attributes>*{margin-left:7px}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i2.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_ATTRIBUTE_CONFIG]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], showCreate: [{
                type: Input
            }], showSelect: [{
                type: Input
            }], heading: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], changed: [{
                type: Output
            }], templ: [{
                type: ContentChild,
                args: [FsAttributeTemplateDirective, { read: TemplateRef }]
            }] } });

class FsAttributeTreeComponent {
    constructor(attributesConfig, dialog, cdRef) {
        this.attributesConfig = attributesConfig;
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.showExpand = true;
        this.showCollapse = true;
        this.showCreate = true;
        this.attributes = [];
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.attributeConfig = this.attributesConfig.getConfig(this.klass);
        this.childAttributeConfig = this.attributeConfig.child;
        this._loadData();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    collapseAll() {
        this.tree.collapseAll();
    }
    expandAll() {
        this.tree.expandAll();
    }
    createRootNode() {
        const attribute = new AttributeItem({ class: this.attributeConfig.klass }, this.attributesConfig);
        const dialogRef = this.dialog.open(FsAttributeEditComponent, {
            data: {
                attribute: attribute,
                klass: this.klass,
                mode: 'create',
                queryConfigs: this.queryConfigs,
            },
            panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${this.klass}`],
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((result) => {
            if (result && result.attribute) {
                const data = new AttributeItem(result.attribute, this.attributesConfig);
                this.tree.append(data.getData());
            }
        });
    }
    _loadData() {
        this.attributesConfig.getAttributeTree({
            class: this.klass,
            queryConfigs: this.queryConfigs,
        })
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            if (response && response.data) {
                this.attributes = response.data;
                this._setTreeConfig();
                this.cdRef.markForCheck();
            }
        });
    }
    _setTreeConfig() {
        this.treeConfig = {
            data: this.attributes,
            childrenName: this.attributeConfig.mapping.childAttributes,
            change: (data) => {
                const payload = data.payload;
                switch (data.type) {
                    case "reorder" /* Reorder */:
                        {
                            const node = payload.node;
                            const item = node && payload.node.data && payload.node.data.original;
                            const event = {
                                class: item.klass,
                                data: this.data,
                                attribute: item,
                                fromParent: payload.fromParent && payload.fromParent.data.id,
                                toParent: payload.toParent && payload.toParent.data.id,
                            };
                            if (node && Array.isArray(node.children)) {
                                event.children = node.children.map((child) => child.data.id);
                            }
                            if (!node.parent) {
                                event.parentIds = this.tree.getData().map((rootNode) => {
                                    return rootNode.id;
                                });
                            }
                            else {
                                event.childIds = node.parent.children.map((child) => child.data.id);
                            }
                            this.attributesConfig.reorderAttributeTree(event)
                                .pipe(takeUntil(this._destroy$))
                                .subscribe(() => {
                            });
                        }
                        break;
                }
            },
            sortBy: this.attributesConfig.sortByAttributeTree.bind(this.attributesConfig),
            canDrop: this.attributesConfig.canDropAttribute.bind(this.attributesConfig),
            actions: [
                {
                    type: TreeActionType.Menu,
                    icon: 'move_vert',
                    items: [
                        {
                            label: 'Edit',
                            click: (node) => {
                                const dialogRef = this.dialog.open(FsAttributeEditComponent, {
                                    data: {
                                        attribute: node.data.original,
                                        klass: node.data.class,
                                        data: this.data,
                                        parent: node.parent && node.parent.data,
                                        mode: 'edit',
                                        queryConfigs: this.queryConfigs,
                                    },
                                    panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${this.klass}`],
                                });
                                dialogRef.afterClosed()
                                    .pipe(takeUntil(this._destroy$))
                                    .subscribe((result) => {
                                    if (result) {
                                        const orig = node.data.original;
                                        const data = new AttributeItem(result.attribute, orig.attributesConfig, orig.parent);
                                        this.tree.updateNodeData(data.getData(), node);
                                    }
                                });
                            }
                        },
                        {
                            label: 'Create ' + this.childAttributeConfig.name,
                            show: (node) => {
                                return node.level === 0;
                            },
                            click: (node) => {
                                const attribute = new AttributeItem({ class: this.attributeConfig.childClass }, this.attributesConfig);
                                const dialogRef = this.dialog.open(FsAttributeEditComponent, {
                                    data: {
                                        attribute: attribute,
                                        klass: this.attributeConfig.childClass,
                                        data: this.data,
                                        parent: node.data,
                                        mode: 'create',
                                        queryConfigs: this.queryConfigs,
                                    },
                                    panelClass: [`fs-attribute-dialog`, `fs-attribute-dialog-no-scroll`, `fs-attribute-${this.klass}`],
                                });
                                dialogRef.afterClosed()
                                    .pipe(takeUntil(this._destroy$))
                                    .subscribe((result) => {
                                    if (result && result.attribute) {
                                        const orig = node.data.original;
                                        const data = new AttributeItem(result.attribute, orig.attributesConfig, node.data.original);
                                        this.tree.append(data.getData(), node);
                                    }
                                });
                            }
                        },
                        {
                            label: 'Delete',
                            click: (node) => {
                                this._deteleNode(node);
                            }
                        },
                    ]
                }
            ]
        };
    }
    _deteleNode(node) {
        this.attributesConfig.deleteConfirmation(node.data.original)
            .pipe(takeUntil(this._destroy$))
            .subscribe({
            next: () => {
                this.attributesConfig.deleteAttribute(node.data.original)
                    .pipe(takeUntil(this._destroy$))
                    .subscribe(() => {
                    this.tree.remove(node);
                });
            },
            error: () => {
            },
        });
    }
}
FsAttributeTreeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeTreeComponent, deps: [{ token: AttributesConfig }, { token: i2.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributeTreeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributeTreeComponent, selector: "fs-attribute-tree", inputs: { data: "data", klass: ["class", "klass"], heading: "heading", showExpand: "showExpand", showCollapse: "showCollapse", showCreate: "showCreate", queryConfigs: "queryConfigs" }, queries: [{ propertyName: "templ", first: true, predicate: FsAttributeTemplateDirective, descendants: true, read: TemplateRef }], viewQueries: [{ propertyName: "tree", first: true, predicate: FsTreeComponent, descendants: true }], ngImport: i0, template: "<div class=\"heading\">\n  <h2 *ngIf=\"heading\">\n    {{ heading }}\n  </h2>\n  <ng-container *ngIf=\"showExpand || showCollapse || showCreate\">\n    <div class=\"attribute-tree-actions\">\n        <button *ngIf=\"showExpand\" mat-button (click)=\"expandAll()\">Expand All</button>\n        &nbsp;\n        <button *ngIf=\"showCollapse\" mat-button (click)=\"collapseAll()\">Collapse All</button>\n        &nbsp;\n        <button *ngIf=\"showCreate\" mat-raised-button color=\"primary\" (click)=\"createRootNode()\">\n          Create {{ attributeConfig.name }}\n        </button>\n    </div>\n\n    <fs-menu class=\"attribute-tree-actions-menu\">\n      <ng-template fs-menu-item\n                   [ngIf]=\"showExpand\"\n                   (click)=\"expandAll()\">\n        Expand All\n      </ng-template>\n      <ng-template fs-menu-item\n                   [ngIf]=\"showCollapse\"\n                   (click)=\"collapseAll()\">\n        Collapse All\n      </ng-template>\n      <ng-template fs-menu-item\n                   [ngIf]=\"showCreate\"\n                   (click)=\"createRootNode()\">\n        Create {{ attributeConfig.name }}\n      </ng-template>\n    </fs-menu>\n  </ng-container>\n</div>\n<fs-tree *ngIf=\"treeConfig\" [config]=\"treeConfig\">\n  <ng-template fsTreeNode\n               let-name=\"name\"\n               let-level=\"level\"\n               let-image=\"image\"\n               let-color=\"backgroundColor\"\n               let-configs=\"configs\"\n  >\n    <img *ngIf=\"image && level === 0\" [src]=\"image\" alt=\"\">\n    <div class=\"color\"\n         *ngIf=\"level === 0 && color\"\n         [style.background]=\"color\"\n    ></div>\n    <ng-template\n      [ngTemplateOutlet]=\"templ || defaultNodeTemplate\"\n      [ngTemplateOutletContext]=\"{ name: name, level: level, configs: configs }\"\n    ></ng-template>\n  </ng-template>\n</fs-tree>\n\n<ng-template #defaultNodeTemplate let-name=\"name\">\n  {{ name }}\n</ng-template>\n", styles: ["img{width:32px;height:32px;border-radius:50%;margin-right:10px}.color{display:inline-block;width:30px;height:30px;border-radius:50%;border:1px solid #ddd;margin-right:10px}.heading{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap}.heading h2{flex:1 0 auto}.heading .attribute-tree-actions-menu{display:none}@media only screen and (max-width: 800px){.heading h2{flex:0 0 auto}.heading .attribute-tree-actions{display:none}.heading .attribute-tree-actions-menu{display:initial}}\n"], components: [{ type: i3$3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4$2.FsMenuComponent, selector: "fs-menu", inputs: ["class", "buttonClass", "buttonType", "buttonColor"], outputs: ["opened", "closed"] }, { type: i5$2.FsTreeComponent, selector: "fs-tree", inputs: ["config"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i10.FsButtonDirective, selector: "[mat-raised-button],[mat-button],[mat-flat-button],[mat-stroked-button]", inputs: ["name", "dirtySubmit", "form"] }, { type: i4$2.FsMenuItemDirective, selector: "fs-menu-group,[fs-menu-item]" }, { type: i5$2.FsTreeNodeDirective, selector: "[fsTreeNode]", inputs: ["class"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attribute-tree', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"heading\">\n  <h2 *ngIf=\"heading\">\n    {{ heading }}\n  </h2>\n  <ng-container *ngIf=\"showExpand || showCollapse || showCreate\">\n    <div class=\"attribute-tree-actions\">\n        <button *ngIf=\"showExpand\" mat-button (click)=\"expandAll()\">Expand All</button>\n        &nbsp;\n        <button *ngIf=\"showCollapse\" mat-button (click)=\"collapseAll()\">Collapse All</button>\n        &nbsp;\n        <button *ngIf=\"showCreate\" mat-raised-button color=\"primary\" (click)=\"createRootNode()\">\n          Create {{ attributeConfig.name }}\n        </button>\n    </div>\n\n    <fs-menu class=\"attribute-tree-actions-menu\">\n      <ng-template fs-menu-item\n                   [ngIf]=\"showExpand\"\n                   (click)=\"expandAll()\">\n        Expand All\n      </ng-template>\n      <ng-template fs-menu-item\n                   [ngIf]=\"showCollapse\"\n                   (click)=\"collapseAll()\">\n        Collapse All\n      </ng-template>\n      <ng-template fs-menu-item\n                   [ngIf]=\"showCreate\"\n                   (click)=\"createRootNode()\">\n        Create {{ attributeConfig.name }}\n      </ng-template>\n    </fs-menu>\n  </ng-container>\n</div>\n<fs-tree *ngIf=\"treeConfig\" [config]=\"treeConfig\">\n  <ng-template fsTreeNode\n               let-name=\"name\"\n               let-level=\"level\"\n               let-image=\"image\"\n               let-color=\"backgroundColor\"\n               let-configs=\"configs\"\n  >\n    <img *ngIf=\"image && level === 0\" [src]=\"image\" alt=\"\">\n    <div class=\"color\"\n         *ngIf=\"level === 0 && color\"\n         [style.background]=\"color\"\n    ></div>\n    <ng-template\n      [ngTemplateOutlet]=\"templ || defaultNodeTemplate\"\n      [ngTemplateOutletContext]=\"{ name: name, level: level, configs: configs }\"\n    ></ng-template>\n  </ng-template>\n</fs-tree>\n\n<ng-template #defaultNodeTemplate let-name=\"name\">\n  {{ name }}\n</ng-template>\n", styles: ["img{width:32px;height:32px;border-radius:50%;margin-right:10px}.color{display:inline-block;width:30px;height:30px;border-radius:50%;border:1px solid #ddd;margin-right:10px}.heading{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap}.heading h2{flex:1 0 auto}.heading .attribute-tree-actions-menu{display:none}@media only screen and (max-width: 800px){.heading h2{flex:0 0 auto}.heading .attribute-tree-actions{display:none}.heading .attribute-tree-actions-menu{display:initial}}\n"] }]
        }], ctorParameters: function () { return [{ type: AttributesConfig }, { type: i2.MatDialog }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], klass: [{
                type: Input,
                args: ['class']
            }], heading: [{
                type: Input
            }], showExpand: [{
                type: Input
            }], showCollapse: [{
                type: Input
            }], showCreate: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], templ: [{
                type: ContentChild,
                args: [FsAttributeTemplateDirective, { read: TemplateRef }]
            }], tree: [{
                type: ViewChild,
                args: [FsTreeComponent]
            }] } });

class FsAttributesComponent {
    constructor(el, attributesConfig, cdRef) {
        this.el = el;
        this.attributesConfig = attributesConfig;
        this.cdRef = cdRef;
        this._attributes = [];
        this.dataReceived = new EventEmitter();
        // @HostBinding('class')
        // public hostClass = '';
        this._destroy$ = new Subject();
    }
    set attributes(value) {
        this._attributes = value;
        this.hasAttributes = value.length;
    }
    ngOnInit() {
        if (this.data) {
            this.fetch();
        }
        this.el.nativeElement.classList.add('fs-attributes');
        this.el.nativeElement.classList.add('fs-attribute');
        this.el.nativeElement.classList.add('fs-attribute-' + this.klass);
        // this.hostClass = 'fs-attribute fs-attribute-' + this.klass;
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    fetch() {
        const e = {
            data: this.data,
            class: this.klass,
            queryConfigs: this.queryConfigs,
        };
        this.attributesConfig.getSelectedAttributes(e)
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            this.attributes = response.data;
            this.dataReceived.emit(cloneDeep(response.data));
            this.cdRef.markForCheck();
        });
    }
}
FsAttributesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributesComponent, deps: [{ token: i0.ElementRef }, { token: AttributesConfig }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAttributesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: FsAttributesComponent, selector: "fs-attributes", inputs: { config: "config", attributes: "attributes", klass: ["class", "klass"], data: "data", size: "size", queryConfigs: "queryConfigs", hasAttributes: "hasAttributes", active: "active" }, outputs: { dataReceived: "dataReceived" }, host: { properties: { "class.has-attributes": "this.hasAttributes", "class.active": "this.active" } }, queries: [{ propertyName: "templ", first: true, predicate: FsAttributeTemplateDirective, descendants: true, read: TemplateRef }], ngImport: i0, template: "<fs-attribute\n  *ngFor=\"let attribute of _attributes\"\n  [attribute]=\"attribute\"\n  [size]=\"size\"\n  [class]=\"klass\">\n  <ng-template\n    [ngTemplateOutlet]=\"templ || defaultTemplate\"\n    [ngTemplateOutletContext]=\"{ attribute: attribute }\"\n  ></ng-template>\n</fs-attribute>\n\n<ng-template #defaultTemplate let-attribute=\"attribute\">\n  {{ attribute.name }}\n</ng-template>\n", styles: [":host.fs-attributes{display:inline-flex;flex-direction:row;flex-wrap:wrap;align-items:center}:host.fs-attributes.has-attributes{margin-top:-7px;margin-left:-7px}:host.fs-attributes.has-attributes fs-attribute{margin-top:7px;margin-left:7px}:host.fs-attributes.has-attributes fs-attribute:last-child{margin-right:0}:host.fs-attributes.has-attributes[size=small]{margin-top:-5px;margin-left:-5px}:host.fs-attributes.has-attributes[size=small] fs-attribute{margin-top:5px;margin-left:5px}:host.fs-attributes.has-attributes[size=tiny]{margin-top:-3px;margin-left:-3px}:host.fs-attributes.has-attributes[size=tiny] fs-attribute{margin-top:3px;margin-left:3px}:host.fs-attributes ::ng-deep .fs-chip{margin-top:0}\n"], components: [{ type: FsAttributeComponent, selector: "fs-attribute", inputs: ["config", "removable", "selectable", "size", "selected", "attribute", "class"], outputs: ["selectedToggled"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fs-attributes', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fs-attribute\n  *ngFor=\"let attribute of _attributes\"\n  [attribute]=\"attribute\"\n  [size]=\"size\"\n  [class]=\"klass\">\n  <ng-template\n    [ngTemplateOutlet]=\"templ || defaultTemplate\"\n    [ngTemplateOutletContext]=\"{ attribute: attribute }\"\n  ></ng-template>\n</fs-attribute>\n\n<ng-template #defaultTemplate let-attribute=\"attribute\">\n  {{ attribute.name }}\n</ng-template>\n", styles: [":host.fs-attributes{display:inline-flex;flex-direction:row;flex-wrap:wrap;align-items:center}:host.fs-attributes.has-attributes{margin-top:-7px;margin-left:-7px}:host.fs-attributes.has-attributes fs-attribute{margin-top:7px;margin-left:7px}:host.fs-attributes.has-attributes fs-attribute:last-child{margin-right:0}:host.fs-attributes.has-attributes[size=small]{margin-top:-5px;margin-left:-5px}:host.fs-attributes.has-attributes[size=small] fs-attribute{margin-top:5px;margin-left:5px}:host.fs-attributes.has-attributes[size=tiny]{margin-top:-3px;margin-left:-3px}:host.fs-attributes.has-attributes[size=tiny] fs-attribute{margin-top:3px;margin-left:3px}:host.fs-attributes ::ng-deep .fs-chip{margin-top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: AttributesConfig }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { config: [{
                type: Input
            }], attributes: [{
                type: Input,
                args: ['attributes']
            }], klass: [{
                type: Input,
                args: ['class']
            }], data: [{
                type: Input
            }], size: [{
                type: Input
            }], queryConfigs: [{
                type: Input
            }], hasAttributes: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-attributes']
            }], active: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.active']
            }], dataReceived: [{
                type: Output
            }], templ: [{
                type: ContentChild,
                args: [FsAttributeTemplateDirective, { read: TemplateRef }]
            }] } });

class FsAttributeModule {
    static forRoot(config) {
        return {
            ngModule: FsAttributeModule,
            providers: [
                { provide: FS_ATTRIBUTE_DEFAULT_CONFIG, useValue: config || {} },
                AttributesConfig,
            ]
        };
    }
}
FsAttributeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsAttributeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeModule, declarations: [FsAttributeComponent,
        FsAttributesComponent,
        FsAttributeFieldComponent,
        FsAttributeSelectorComponent,
        FsAttributeEditComponent,
        FsAttributeManageComponent,
        FsAttributeListComponent,
        FsAttributeSelectComponent,
        FsAttributeAutocompleteChipsComponent,
        FsAttributeComponentWrapperComponent,
        FsAttributeTreeComponent,
        FsAttributeFieldGroupsComponent,
        FsAttributeSelectorWithGroupsComponent,
        AttributeSearchComponent,
        FsAttributeAutocompleteComponent,
        FsAttributeListColumnDirective,
        FsAttributeTemplateDirective,
        FsAttributeAutocompleteChipsStaticDirective], imports: [FormsModule,
        CommonModule,
        MatChipsModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatSelectModule,
        FsColorPickerModule,
        FsFormModule,
        FsLabelModule,
        FsAutocompleteChipsModule,
        FsChipModule,
        FsListModule,
        FsScrollModule,
        FsFileModule,
        FsTreeModule,
        FsAutocompleteModule,
        FsMenuModule,
        FsDialogModule], exports: [FsAttributeComponent,
        FsAttributesComponent,
        FsAttributeFieldComponent,
        FsAttributeListComponent,
        FsAttributeSelectComponent,
        FsAttributeAutocompleteChipsComponent,
        FsAttributeTreeComponent,
        FsAttributeFieldGroupsComponent,
        FsAttributeAutocompleteComponent,
        FsAttributeSelectorComponent,
        FsAttributeSelectorWithGroupsComponent,
        FsAttributeListColumnDirective,
        FsAttributeTemplateDirective,
        FsAttributeAutocompleteChipsStaticDirective] });
FsAttributeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeModule, imports: [[
            FormsModule,
            CommonModule,
            MatChipsModule,
            MatIconModule,
            MatDialogModule,
            MatButtonModule,
            MatInputModule,
            MatFormFieldModule,
            MatAutocompleteModule,
            MatSelectModule,
            FsColorPickerModule,
            FsFormModule,
            FsLabelModule,
            FsAutocompleteChipsModule,
            FsChipModule,
            FsListModule,
            FsScrollModule,
            FsFileModule,
            FsTreeModule,
            FsAutocompleteModule,
            FsMenuModule,
            FsDialogModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsAttributeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        MatChipsModule,
                        MatIconModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatAutocompleteModule,
                        MatSelectModule,
                        FsColorPickerModule,
                        FsFormModule,
                        FsLabelModule,
                        FsAutocompleteChipsModule,
                        FsChipModule,
                        FsListModule,
                        FsScrollModule,
                        FsFileModule,
                        FsTreeModule,
                        FsAutocompleteModule,
                        FsMenuModule,
                        FsDialogModule,
                    ],
                    exports: [
                        FsAttributeComponent,
                        FsAttributesComponent,
                        FsAttributeFieldComponent,
                        FsAttributeListComponent,
                        FsAttributeSelectComponent,
                        FsAttributeAutocompleteChipsComponent,
                        FsAttributeTreeComponent,
                        FsAttributeFieldGroupsComponent,
                        FsAttributeAutocompleteComponent,
                        FsAttributeSelectorComponent,
                        FsAttributeSelectorWithGroupsComponent,
                        FsAttributeListColumnDirective,
                        FsAttributeTemplateDirective,
                        FsAttributeAutocompleteChipsStaticDirective
                    ],
                    declarations: [
                        FsAttributeComponent,
                        FsAttributesComponent,
                        FsAttributeFieldComponent,
                        FsAttributeSelectorComponent,
                        FsAttributeEditComponent,
                        FsAttributeManageComponent,
                        FsAttributeListComponent,
                        FsAttributeSelectComponent,
                        FsAttributeAutocompleteChipsComponent,
                        FsAttributeComponentWrapperComponent,
                        FsAttributeTreeComponent,
                        FsAttributeFieldGroupsComponent,
                        FsAttributeSelectorWithGroupsComponent,
                        AttributeSearchComponent,
                        FsAttributeAutocompleteComponent,
                        FsAttributeListColumnDirective,
                        FsAttributeTemplateDirective,
                        FsAttributeAutocompleteChipsStaticDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AttributeItem, FS_ATTRIBUTE_CONFIG, FS_ATTRIBUTE_DEFAULT_CONFIG, FS_ATTRIBUTE_FIELD_DATA, FsAttributeAutocompleteChipsComponent, FsAttributeAutocompleteChipsStaticDirective, FsAttributeAutocompleteComponent, FsAttributeComponent, FsAttributeFieldComponent, FsAttributeFieldGroupsComponent, FsAttributeListColumnDirective, FsAttributeListComponent, FsAttributeModule, FsAttributeSelectComponent, FsAttributeSelectorComponent, FsAttributeSelectorWithGroupsComponent, FsAttributeService, FsAttributeTemplateDirective, FsAttributeTreeComponent, FsAttributesComponent, getAttributeValue, setAttributeValue };
